{
  "ACCESS_SELECT_POLICY": "To get started, please select the policy you want to access.",
  "AVAILABLE_MASSACHUSETTS_POLICY": "Only available for Massachusetts policies",
  "APPLIES_MASSACHUSETTS_POLICIES": "Applies to Massachusetts policies only.",
  "ASK_QUESTION": "Ask a question",
  "ADD_YOUR_MESSAGE": "Question",
  "AUTOPAY": "Autopay",
  "BANK_NAME": "Bank name",
  "BILLING_DETAILS": "Billing details",
  "LOGIN": "Log in",
  "LOGIN_ACCOUNT_EXISTS": "Login",
  "REGISTER": "Register",
  "CONF_PASS": "Confirm password",
  "CONTACT_AGENT_ABOUT_COVERAGES_DISCOUNT": "Contact your agent to discuss your coverages and explore bundling or discount options.",
  "CANCEL": "Cancel",
  "SIGNUPTEXT": "We are making awesome insurance. Could we take care of you too?",
  "OUR_COMPANIES": "Our companies",
  "PRIVACY": "Privacy Policy",
  "TERMS": "Terms & Conditions",
  "QUOTE": "Quote Disclosure",
  "CAREERS": "Careers",
  "CONTACT": "Contact",
  "CUSTOMIZE_ACTIONS": "Your space, your way – customize and organize the actions you use most.",
  "RIGHTS": "Mapfre U.S.A Corp. All rights reserved.",
  "EMAIL_REQUIRED": "Email is required.",
  "EMAIL_INVALID": "Email is invalid.",
  "ENROLL_AUTOPAY": "Enroll in autopay",
  "ENROLL_PAPERLESS": "Enroll in paperless",
  "EXPLORE_FAQS": "Explore FAQs",
  "FIND_ACCONT_INFO": "Find all your account information here, along with access to helpful resources.",
  "FIND_ROADSIDE_AID": "Find roadside aid",
  "FIRST_TIME": "First time",
  "FOOTER_TEXT": "Mapfre Insurance is a brand and service of Mapfre U.S.A Corp. and its affiliates. Learn about",
  "FOR_MASSACHUSETTS_POLICIES_ONLY": "For Massachusetts policies only",
  "FOR_CALIFORNIA_POLICIES_ONLY": "For CA policies only",
  "FOR_OTHER_STATES_OUTSIDE_MASSACHUSETTS": "For all other states outside of Massachusetts",
  "FOR_OTHER_STATES_OUTSIDE_CALIFORNIA": "For all the states (except CA)",
  "FORGOT_PASS": "Forgot password?",
  "FREQUENT_ACTION": "Frequent actions",
  "PASSWORD_REQUIRED": "Password is required.",
  "CONF_PASS_REQUIRED": "Confirm password is required.",
  "PASSWORDS_NOT_MATCH": "Password and confirm password does not match.",
  "SEE_DETAILS": "Policy details",
  "SEE_LAST_INVOICE": "See last invoice",
  "SIGN_IN": "Sign in",
  "CUSTOMER_ACCESS": "Customer log in",
  "REMEMBER_ME": "Remember me",
  "CREATE_ACCOUNT": "Create account",
  "CREATE_NEW_ACCOUNT": "create new account",
  "SHOW_PASSWORD": "Show password",
  "HIDE_PASSWORD": "Hide password",
  "YOUR_PASSWORD_SHOULD_BE": "Your password should be:",
  "PASSWORD_REQUIREMENTS": "Password requirements:",
  "DISCOVER_REWARDS": "Discover rewards",
  "DOES_NOT_PASS": "Does not pass",
  "PASSES_THE_RULE": "Passes the pule",
  "IMMEDIATE_ASSISTANCE": "If your question requires immediate assistance, please ",
  "INFO_SELECT_POLICY": "To get started, please select the policy you want information on.",
  "INVALID_USERNAME_PASSWORD": "Invalid email/password combination",
  "MANAGE_INSURANCE2": "Manage your insurance, make payments, claims, and more!",
  "MIN_AMT_DUE": "Min amount due",
  "MINIMUM_AMT_DUE": "Minimum amount due",
  "MIN_AMT_DUE_DISCLAIMER": "Min amount due***",
  "MODAL_HELP_TITLE": "Need help?",
  "MODAL_HELP_CUSTOMER_PORTAL": "Your Mapfre account allows you to access your policy documents, report claims, and make payments any time.",
  "MODAL_HELP_TROUBLE_ACCESSING": "Trouble accessing your account?",
  "MODAL_HELP_DONT_HESITATE": "Please don’t hesitate to contact our Customer service department.",
  "MODAL_USER_LANGUAGE_TITLE": "LANGUAGE",
  "CALL_US": "Call us",
  "CALL_US_NUMBER": "1-800-922-8276",
  "EMAIL_US": "Email us",
  "EMAIL_US_EMAIL": "generalcomments@mapfreusa.com",
  "FOOTER_DEFAULT_LANGUAGE": "ENGLISH",
  "FOOTER_COPY_RIGHT": "Mapfre U.S.A Corp. All rights reserved.",
  "FORGOT_PASSWORD_TITLE": "Forgot your password?",
  "FORGOT_PASSWORD_PARAGRAPH": "We'll send you an email with instructions",
  "FORGOT_PASSWORD_SUBMIT_BUTTON": "Request new password",
  "CHECK_YOUR_EMAIL_TITLE": "Check your email",
  "CHECK_YOUR_EMAIL_PARAGRAPH": "We have sent you an email with a link to reset your password to:",
  "EMAIL": "Email",
  "PASSWORD": "Password",
  "VALID_EMAIL_VALIDATION_MESSAGE": "Enter a valid email format",
  "EMAIL_COULD_NOT_VALIDATE": "We could not validate your email",
  "INVALID_EMAIL_PASSWORD": "Invalid email/password combination",
  "ACCOUNT_IS_LOCKED": "Too many login attempts. For security reasons, your account has been locked for 30 minutes. Please try again later or use 'Forgot password' to regain access.",
  "CAPS_LOCK": "Caps lock is on",
  "FORGOT_EMAIL_CONFIMATION_SUBTITLE": "Didn't receive the email?",
  "FORGOT_EMAIL_CONFIMATION_COPY": "Also, check your spam for a message with the subject:",
  "FORGOT_EMAIL_SUBJECT_LINE": "Mapfre Insurance - IMPORTANT - Reset your password",
  "FORGOT_EMAIL_SEND_AGAIN": "Resend email",
  "FORGOT_EMAIL_REVIEW_ME": "Please review",
  "CREATE_PASSWORD": "Password",
  "CREATE_NEW_PASSWORD": "Create new password",
  "VALID_PASSWORD_VALIDATION_MESSAGE": "Wrong Password",
  "PASSWORD_RESET_CONFIRMATION_PARGRAPH": "Your password was reset",
  "PASSWORD_RESET_CONFIRMATION_TITLE": "Confirmation",
  "LINK_HAS_EXPIRED": "Link has expired",
  "LINK_HAS_EXPIRED_PARAGRAPH": "For security reasons, these links expire after 48 hours.",
  "REQUEST_NEW_LINK": "Request a new link",
  "TOO_MANY_ATTEMPTS_TITLE": "Too many attempts",
  "TOO_MANY_ATTEMPTS_PARAGRAPH": "You have reached the maximum attemps for that email. For security reasons we have blocked that email to continue with this action for the next",
  "TIME": "24 hours",
  "EFT_TIME": "Time",
  "FIRST_NAME": "First name",
  "MIDDLE_INITIAL": "MI",
  "LAST_NAME": "Last name",
  "CONTINUE": "Continue",
  "ALL_READY_IN_USE": "is already in use",
  "IF_YOU_DONT_REMEMBER": "If you don't remember creating an account, contact our Customer service department",
  "NEW_PASSWORD": "Set new password",
  "ADD_POLICY_TITLE": "Let's find your policy",
  "POLICY_NUMBER": "Enter policy number",
  "I_AM_THE_POLICY_HOLDER": "I am the policy holder or an authorized person",
  "ADD_POLICY": "Add policy",
  "MODAL_WHERE_CAN_I_LINK": "Where can I find my policy number?",
  "MODAL_WHERE_CAN_I_LINK_ADD_POLICY": "Where can I find my policy number",
  "MODAL_WHERE_CAN_I_TITLE": "Locate your policy number",
  "POLICY_DOCUMENT": "Policy document",
  "BILLING_DOCUMENT": "Billing invoice",
  "BILLING_SECTION_AUTOPAY_STATEMENT": "Check the documents tab in the billing section for the autopay statement.",
  "BILLING_SECTION_INVOICE": "Check the documents tab in the billing section for the invoice.",
  "BOP": "Business policy detected",
  "SERVICE_NOT_AVAILABLE": "This service is currently unavailable.",
  "BOP_POLICIES_CANNOT_BE_ACCESS_VIA_CUSTOMER_PORTAL": "Business policies cannot currently be accessed via the Customer Portal.",
  "VERIFY_ACCOUNT_TITLE": "Let's verify your account",
  "VERIFY_ACCOUNT_WE_SENT_AN_EMAIL": "We sent an email with a verification link to:",
  "VERIFY_ACCOUNT_SUBJECT_LINE": "Mapfre Insurance - IMPORTANT - Verify your account",
  "VERIFY_ACCOUNT_INFO_DIV": "Don't have access to your email or want to validate with your policy number?",
  "VERIFY_ACCOUNT_GO_TO_ADD_POLICY": "Verify using your policy details",
  "NOT_FOUND": "Policy not found",
  "NOTFOUND_POLICY_NOT_FOUND": "Information doesn't match with our records",
  "POLICY_INFO_TITLE": "Policy information requested",
  "POLICY_INFO_HOLDER_NAME": "Policy holder name",
  "POLICY_INFO_NUMBER": "Policy number",
  "EDIT_POLICY_INFO": "Edit Policy information",
  "TRY_AGAIN": "Try again",
  "NOTFOUND_NEED_ASSISTANCE": "If you need personal assistance, contact our Customer Service department.",
  "NOTFOUND_IF_YOU_PURCHASE": "If you purchased your policy in the last 2 days, it may still be processing. Sorry for the inconvenience!",
  "TRY_AGAIN_WITH_A_DIFFERENT": "Try another policy",
  "EDIT_POLICY": "Review your details",
  "EDITPOLICY_REVIEW_POLICY": "Review your policy information and confirm.",
  "CONFIRM": "Confirm details",
  "POLICYBELONGS_TO_ANOTHER": "Policy found",
  "POLICYBELONGS_INFO_TITLE": "Verify that you own this policy",
  "POLICYBELONGS_TYPE_NUMBER_PERSONAL": "Personal",
  "POLICYBELONGS_TYPE_NUMBER_BIZ": "Business",
  "POLICYBELONGS_TYPE_NUMBER_AUTO": "Auto",
  "POLICYBELONGS_TYPE_NUMBER_HOME": "Home",
  "EFFECTIVE_DATE": "Effective date",
  "POLICYBELONGS_LEGAL": "By clicking continue, you are confirming that you own the policy specified above or have been authorized by the policyholder to act on his or her behalf with respect to such policy.",
  "POLICYBELONGS_AUTHORIZED": "Continue",
  "REVIEW_POLICY_TITLE": "Welcome to your Mapfre account",
  "REVIEWPOLICY_INFO_TITLE": "Here is your policy information",
  "REVIEWPOLICY_WALLETCARD": "Add your Mapfre card to your phone",
  "VALID_NAME_VALIDATION_MESSAGE": "Please use a valid name",
  "ENTER_VALID_FIRST_NAME": "Enter a valid first name",
  "ENTER_VALID_LAST_NAME": "Enter a valid last name",
  "VALID_POLICY_VALIDATION_MESSAGE": "Please enter a valid policy number",
  "CREATE_ACCOUNT_LEGAL_ONE": "By clicking CONTINUE, you are confirming that you have read and agree to our ",
  "CREATE_ACCOUNT_LEGAL_TWO": "Terms & Conditions",
  "CREATE_ACCOUNT_LEGAL_THREE": "and",
  "CREATE_ACCOUNT_LEGAL_FOUR": "Privacy Policy",
  "CAUTION_CREATE_ACCOUNT": "At this moment of time, an email cannot be 20 characters long.",
  "SUCCESS_FORGOT_PASSWORD": "Password successfully updated!",
  "BACK": "Back",
  "PASSWORD_RULE_ONE": "One lowercase letter (a-z)",
  "PASSWORD_RULE_TWO": "One number (0-9)",
  "PASSWORD_RULE_THREE": "One symbol (!, @, #, $)",
  "PASSWORD_RULE_FOUR": "At least 7 characters long",
  "PASSWORD_RULE_FIVE": "At the most 24 characters long",
  "PASSWORD_RULE_SIX": "One uppercase letter (A-Z)",
  "WALLET_TITLE_ONE": "Get your",
  "WALLET_TITLE_TWO": "You'll never lose your policy details",
  "WALLET_TITLE_THREE": "Take advantage of your card",
  "WALLET_CONTENT_ONE": "Learn the benefits of keeping your policy information in a digital wallet card.",
  "WALLET_CONTENT_TWO": "With a digital wallet card, your information is always at your fingertips!",
  "WALLET_CONTENT_THREE": "You can file a claim, contact your agent, access to your policy details any time",
  "WALLET_GET_MY_CARD": "Get my card",
  "WALLET_SKIP": "Skip for now",
  "WALLETBACK_TITLE": "Download now!",
  "WALLETBACK_ANDROID": "As for now Android users will require the WalletPasses app to save it.",
  "WALLETBACK_WALLETPASS": "Download walletPasses",
  "AUTO": "Auto",
  "BALANCE": "Balance",
  "NO_PAYMENTS_DUE": "No payments due",
  "OUTSTANDING_BALANCE": "Outstanding balance",
  "NEXT": "Current amount due",
  "POLICY_BILL_AFFINITY_GROUP": "The billing on this policy is being handled by your agent",
  "PAY_NOW": "Pay now",
  "Billing_Policy_Documents": "Billing, Policy details, & Documents",
  "PROPERTY": "Property",
  "TO": "-",
  "INACTIVE": "Inactive",
  "ACTIVE": "Active",
  "MORE": "More",
  "BEEN_IN_AN_ACCIDENT": "Been in an accident?",
  "BEEN_IN_AN": "Been in an",
  "ACCIDENT": "accident?",
  "REPORT_A_CLAIM": "Report a claim",
  "REPORTCLAIM": "Report a claim",
  "OR_CALL_US": "or call us",
  "MY_INSURANCE": "Insurance",
  "BILLING": "Billing",
  "CLAIMS": "Claims",
  "INFORMATION": "Information",
  "ACCOUNT": "Account",
  "PROFILE_AND_SETTINGS": "Account and settings",
  "LOGOUT": "Logout",
  "POLICY": "Policy",
  "POLICY_OVERVIEW": "Policy overview",
  "DETAILS": "Details",
  "DOCUMENTS": "Documents",
  "DOWNLOAD": "Download",
  "VEHICLES": "Vehicles",
  "ODOMETER_UPDATE_ONE": "Updating your mileage before your next policy renewal could make you eligible for the Annual Mileage Discount.",
  "ODOMETER_UPDATE_TWO": "Want to know more? Click on Update Odometer below.",
  "NEW_DISCOUNTS": "new discounts",
  "LAST_UPDATE": "Last update",
  "UPDATE_MILEAGE": "Update my vehicle mileage",
  "LEGAL": "Our company will use vehicle inspection data from the Registry of Motor Vehicles to determine annual odometer, when possible. The difference is the two most recent odometer readings reported by the Registry within the last 24 months, if at least six months apart, shall be annualized to determine annual odometer. If there is one odometer reading available through the Registry of Motor Vehicles within the past 24 months at the time of verification, the current odometer reading provided above will be used to annualize odometer.",
  "LEGAL_CHECKMARK": "I hereby certify that the information provided is accurate.",
  "POLICY_HOLDER": "Policy holder",
  "POLICY_HOLDER_ONE_WORD": "Policyholder",
  "POLICY_HOLDER_ONE": "To view all listed drivers, coverages, and more go to",
  "POLICY_HOLDER_TWO": "Documents",
  "PRIMARY": "Primary",
  "SECONDARY": "Secondary",
  "SIMPLIFY_BILLING": "Simplify your billing",
  "YOUR_AGENT": "Your agent",
  "ENTER_PHONE": "Enter your phone",
  "PHONE": "Phone",
  "PAPERLESS": "Paperless",
  "PAPERLESS_DISCOUNT": "Paperless discount",
  "PAPERLESS_PARTIAL": "Finish enrolling in paperless to qualify!",
  "AMOUNT_TO_SAVE": "Discount available",
  "ENROLL_NOW": "Enroll now",
  "ENROLL_EPAY": "Enroll now",
  "ENROLLED": "Discount applied",
  "ADDRESS": "Address",
  "MAILING": "Mailing",
  "RESIDENTIAL": "Residential",
  "SAME_AS_MAILING": "Same as residential address",
  "PROPERTY_COVERED": "Property covered",
  "APARTMENT": "Apartment (optional)",
  "RESIDENTIAL_GARAGE": "Will all your vehicles be garaged at this new location?",
  "CHANGE_ADDRESS_MAILING": "Change mailing address",
  "CHANGE_ADDRESS_RESIDENTIAL": "Update residential address",
  "ADDRESS_APT": "Apartment (optional)",
  "SAVA_CHANGES": "Save changes",
  "SAVE_NEW_ADDRESS": "Save new address",
  "INFORMATION_RENEWAL_ONE": "With automatic renewal, you won't be left with a lapse of insurance due to your policy expiring unknowingly.  All that is required is payment on your renewal bill and you are all set!  Below are steps in the process along with considerations you may want to discuss with your agent.",
  "INFORMATION_RENEWAL_TWO": "Review policy",
  "INFORMATION_RENEWAL_THREE": "45-60 days prior to your renewal date, your Mapfre renewal package arrives. Your policy will be mailed to you  (emailed to our ePolicy customers). Review your policy to see if anything should be changed.",
  "INFORMATION_RENEWAL_FOUR": "Why did my rate change?",
  "INFORMATION_RENEWAL_FIVE": "When you get your renewal offer, you may notice that your rate has changed. This can happen for a number of reasons.",
  "INFORMATION_RENEWAL_SIX": "Life events",
  "INFORMATION_RENEWAL_SEVEN": "Because your car insurance rate is primarily based on factors specific to you, certain changes in your life could affect your rate.  For instance, changes to your coverage level, deductibles, or annual mileage could either increase or decrease your premium.  Also, if you’ve moved, added or removed a driver, or changed the car you drive, you could also see some fluctuation in how much you pay.",
  "INFORMATION_RENEWAL_EIGHT": "Driving experience",
  "INFORMATION_RENEWAL_NINE": "Insurance companies set your premium largely based on risk. Your driving record is a good indicator of how risky you are to insure (in other words, how likely you are to cause an accident).",
  "INFORMATION_RENEWAL_TEN": "Accidents",
  "INFORMATION_RENEWAL_ELEVEN": "Contrary to common belief, not all accidents and car insurance claims will increase your rate. An accident could cause your rate to rise, but it depends on a number of factors (like the severity of the incident, your driving history, and whether you were at fault).",
  "INFORMATION_RENEWAL_TWELVE": "Pay bill",
  "INFORMATION_RENEWAL_THIRTEEN": "Pay your Renewal Bill by the policy effective date to avoid cancellation.",
  "INFORMATION_RENEWAL_FOURTEEN": "If you already have automatic payments set up, your payment will be withdrawn automatically.",
  "INFORMATION_RENEWAL_15": "Switching payment methods?",
  "INFORMATION_RENEWAL_16": "Log into your policy to update your payment method or contact our Customer service department, Monday through Friday, 8 a.m. to 6 p.m.",
  "INFORMATION_RENEWAL_17": "Done!",
  "INFORMATION_RENEWAL_18": "With auto renewal, it's that easy!",
  "INFORMATION_RENEWAL_19": "Policy questions or updates?",
  "INFORMATION_RENEWAL_20": " Renewal is a good time to review your coverages and ensure you are fully protected.",
  "INFORMATION_RENEWAL_21": "Contact your agent if you have questions or changes to your policy, including if you have moved.",
  "INFORMATION_RENEWAL_22": "Do not want to renew? Contact your agent to let them know you would like to cancel at the end of the policy term.  Be sure to have other coverage in place first before cancelling.",
  "INFORMATION_HOME_1": "About Mapfre",
  "INFORMATION_HOME_2": "Mapfre Insurance offers friendly service from over 2,000 profession…",
  "INFORMATION_HOME_3": "Our products",
  "INFORMATION_HOME_4": "Offers a wide range of insurance solutions for the home and vehicle",
  "INFORMATION_HOME_5": "Discounts",
  "INFORMATION_HOME_6": "Mapfre has variety of discounts that will help you to save money in …",
  "INFORMATION_HOME_7": "Renewal process",
  "INFORMATION_HOME_8": "With automatic renewal, you won't be left with a lapse of insurance du…",
  "INFORMATION_HOME_9": "Cancellation process",
  "INFORMATION_HOME_10": "If you want to cancel your auto policy, give us a call at 1-800-922-8276 …",
  "INFORMATION_HOME_11": "Legal terms & conditions",
  "INFORMATION_HOME_12": "Your use of the Online Services portion of this web site is also subject …",
  "INFORMATION_CANCEL_1": "Cancellation process",
  "INFORMATION_CANCEL_2": "If you want to cancel your auto policy, give us a call at 1-800-922-8276,  where our agents are available to help you with this process.",
  "INFORMATION_ABOUT_1": "About Mapfre",
  "INFORMATION_ABOUT_2": "Mapfre Insurance offers friendly service from over 2,000 professionals focused on taking care of you and your family. Know our presence across the world.",
  "INFORMATION_ABOUT_3": "Global Presence",
  "INFORMATION_ABOUT_4": "Mapfre across the globe",
  "INFORMATION_ABOUT_5": "Part of the Mapfre Group - a global insurance group doing business in over 100 countries across five continents. Mapfre has over 36,000 employees serving over 30 million customers worldwide.",
  "INFORMATION_ABOUT_6": "Local focus",
  "INFORMATION_ABOUT_7": "Mapfre in the United States",
  "INFORMATION_ABOUT_8": "Offers a wide range of insurance solutions for the home and vehicle",
  "INFORMATION_ABOUT_9": "Is the 21st largest Property-Casualty Insurer",
  "INFORMATION_ABOUT_10": "Is the 20th largest private passenger auto insurer",
  "INFORMATION_ABOUT_11": "Has a network of more than 5000 independent agents and brokers",
  "INFORMATION_ABOUT_12": "Has a presence in 14 states",
  "INFORMATION_ABOUT_13": "Rated “A” (Excellent) by A.M. Best",
  "INFORMATION_DISCOUNTS_1": "Discounts",
  "INFORMATION_DISCOUNTS_2": "Mapfre Insurance offers a multitude of discounts to ensure that you’re getting the most value out of your policy. Auto and vehicle discounts include:",
  "INFORMATION_DISCOUNTS_3": "AAA member discounts",
  "INFORMATION_DISCOUNTS_4": "By insuring your auto, home and umbrella through us, we offer a homeowner insurance discount and a discount on auto insurance ",
  "INFORMATION_DISCOUNTS_5": "By insuring both your auto and home through us, we offer a homeowners insurance discount and a discount on auto insurance ",
  "INFORMATION_DISCOUNTS_6": "Shop smart credit ",
  "INFORMATION_DISCOUNTS_7": "Welcome Back credit when prior Loyalty applies. ",
  "INFORMATION_DISCOUNTS_8": "Paid-in-Full discount ",
  "INFORMATION_DISCOUNTS_9": "Good Student discount ",
  "INFORMATION_DISCOUNTS_10": "Student away from home discount ",
  "INFORMATION_DISCOUNTS_11": "Annual mileage discount ",
  "INFORMATION_DISCOUNTS_12": "Smart driver discount (Ask about InControl Crash Prevention Training or teenSmart Training Programs) ",
  "INFORMATION_DISCOUNTS_13": "Multi-car discount ",
  "INFORMATION_DISCOUNTS_14": "Green discount ",
  "INFORMATION_DISCOUNTS_15": "Clean in Three discount ",
  "INFORMATION_PRODUCTS_1": "Our products",
  "INFORMATION_PRODUCTS_2": "We offer a wide range of insurance solutions for the home, vehicle, and anything else you want to protect.",
  "INFORMATION_PRODUCTS_3": "Auto",
  "INFORMATION_PRODUCTS_4": "Get a quote",
  "INFORMATION_PRODUCTS_5": "Property",
  "INFORMATION_PRODUCTS_6": "Life",
  "INFORMATION_PRODUCTS_7": "Travel",
  "INFORMATION_PRODUCTS_8": "Business",
  "INFORMATION_PRODUCTS_9": "Umbrella",
  "INFORMATION_PRODUCTS_10": "Motorcycle",
  "INFORMATION_PRODUCTS_11": "Watercraft",
  "INFORMATION_PRODUCTS_12": "Rec. Vehicle",
  "INFORMATION_LEGAL_1": "Legal terms & conditions",
  "INFORMATION_LEGAL_2": "Mapfre USA and its affiliates, American Commerce Insurance Company℠ (Columbus, Ohio); Citation Insurance Company℠ (Webster, MA); The Commerce Insurance Company℠ (Webster, MA); Commerce West Insurance Company℠ (California COA No. 06715; San Ramon, CA): Mapfre Insurance Company℠ (California COA No. 18643; Florham Park, NJ); and Mapfre Insurance Company of New York℠ (Garden City, NY), insure private passenger automobiles and provide homeowner and other types of insurance for qualified applicants. The companies market collectively under the service mark and brand Mapfre Insurance (“Company”). Not all companies are licensed to do business in all states. Not all products are available in all states.",
  "INFORMATION_LEGAL_3": "Your use of this web site is governed by and subject to these Terms and Conditions. BY USING THE SERVICES MADE AVAILABLE ON THIS WEB SITE YOU ARE INDICATING YOUR AGREEMENT TO BE BOUND BY ALL OF THESE TERMS AND CONDITIONS.",
  "INFORMATION_LEGAL_4": "Your use of the Online Services portion of this web site is also subject to the Online Services Terms and Conditions appearing below. The term 'Terms and Conditions' as used herein includes both the General Terms and Conditions and the Online Services Terms and Conditions.",
  "INFORMATION_LEGAL_5": "This web site presents information and content that is owned or licensed by the Company. When used in these Terms and Conditions, 'we', 'our' and 'us' mean the Company.",
  "INFORMATION_LEGAL_6": "Changes",
  "INFORMATION_LEGAL_7": "The content on this web site and these Terms and Conditions, are subject to change or updating by the Company at any time without prior notice. The changes may include superseding terms and conditions or specific notices. YOU SHOULD REVIEW THESE TERMS AND CONDITIONS FROM TIME TO TIME TO BE AWARE OF ANY CHANGES THAT ARE MADE. YOUR CONTINUING USE OF THIS WEB SITE CONSTITUTES YOUR ACCEPTANCE OF ANY CHANGE OR UPDATE, ALL OF WHICH SHALL BECOME CONTROLLING WHEN POSTED.",
  "INFORMATION_LEGAL_8": "Use of Site By Non-U.S. Persons",
  "INFORMATION_LEGAL_9": "The Company makes no claims that the content on this web site is appropriate or may be downloaded outside of the United States. Access to the content may not be legal by certain persons or in certain countries. If you access the site from outside the United States, you do so at your own risk and are responsible for compliance with the laws of your jurisdiction.",
  "INFORMATION_LEGAL_10": "Privacy Policy",
  "INFORMATION_LEGAL_11": "Your personally identifiable information that we may collect is subject to our Privacy Policy, which is incorporated into these Terms and Conditions by reference.",
  "INFORMATION_LEGAL_12": "Financial Decisions",
  "INFORMATION_LEGAL_13": "As with all financial matters, you should exercise great care in using the information provided on this web site or available through links from this web site. Nothing on this web site should be construed as rendering tax, legal, investment, or accounting advice.",
  "PAPERLESS_SETTINGS": "Paperless settings",
  "ENROLL_NOW_COPY": "Enroll in our autopay plan",
  "ACTIVE_CLAIMS": "Active claims",
  "DATE_OF_LOSS": "Date of loss",
  "CLOSED": "Closed",
  "CLOSED_CLAIMS": "Closed claims",
  "CLAIM_DETAILS": "Claim details",
  "REPORT_CTA": "Have you had an accident or other loss? We are here for you 24/7/365.",
  "WE_ARE_HERE_FOR_YOU": "We are here for you 24/7/365",
  "OR_CALL_US_AT": "Or call us at",
  "REPORT_CLAIM_HERE": " Always here for you 24/7",
  "CLAIM_FAQ_1": "Claims reporting FAQ",
  "CLAIM_FAQ_2": "What should I expect?",
  "CLAIM_FAQ_3": "A representative will gather full detailed information on your loss and enter it electronically into our system. The claim report should take only 10-15 minutes.",
  "CLAIM_FAQ_4": "How do appraisals work?",
  "CLAIM_FAQ_5": "During the initial report, we will create an appraisal for you. Therefore, it is helpful to have the location of the vehicle when you call in the loss. A Physical Damage Adjuster will need the appraisal in order to process and settle your claim.",
  "CLAIM_FAQ_6": "What if someone was injured?",
  "CLAIM_FAQ_7": "If someone was injured in the accident, we will create a claim and have a Casualty Adjuster assigned. This person will be responsible for the settlement of any injury claims. ",
  "CLAIM_FAQ_8": "Who is handling my claim?",
  "CLAIM_FAQ_9": "When you report your claim to us, our Claims Service Center Representatives will work with you to gather the information and will assign a Claim Representative to handle your needs. Additionally, for auto claims, a Mapfre Insurance Appraiser will be assigned to inspect your vehicle and write a damage appraisal.                ",
  "CLAIM_FAQ_10": "Can I rent a car? ",
  "CLAIM_FAQ_11": "If your policy includes coverage for a substitute vehicle, and your vehicle is not drivable or in the shop for repairs, your Claim Representative will assist you in obtaining a rental vehicle. Mapfre Insurance has a list of preferred rental companies you may wish to select from.",
  "CLAIM_FAQ_12": "How do I handle emergency repairs?",
  "CLAIM_FAQ_13": "Sometimes a property claim requires immediate attention, such as emergency clean-up or temporary lodging arrangements if your home is not habitable. We have staff members available to coordinate the arrangements to address your emergency situation as quickly as possible.",
  "NO_CLAIMS_CTA": "Well done, stay safe ✌️ ",
  "NO_CLAIMS_MSG": "Keep it up ✌️",
  "YOU_HAVE_NO_CLAIMS": "You have no Claims!",
  "SEND_CLAIM_DOCUMENTS": "Send claim documents",
  "EXPEDITE_CLAIM_PROCESS": "Expedite your claim process by",
  "SENDING_YOUR_DOCUMENTS": "sending your documents!",
  "SEND_DOCUMENTS": "Send documents",
  "NEED_HELP": "Need help?",
  "CHECK_OUT_SOME_MOST": "Check out some most",
  "COMMON_QUESTIONS": "common questions!",
  "FAQS": "FAQs",
  "SURCHARGES_MAY_APPLY": "Surcharges may apply",
  "CLAIMANT": "Claimant",
  "PAYMENTS_TO_DATE": "Payments to date",
  "LOCATION": "Location",
  "DESCRIPTION": "Description",
  "CLAIMANT_ADJUSTER": "Claim adjuster",
  "FAX": "fax",
  "APPRAISAL_INFORMATION": "Appraisal information",
  "APPRAISAL_MSG_AUTO": "A licensed appraiser will be assigned to view your vehicle and write an appraisal for any accident related damage. Typically, the appraisal is received within 5 business days from the day the vehicle is seen by an appraiser. It is mailed to both you and your claim adjuster. Your claim adjuster will receive the copy of appraisal on or about the same day as you.",
  "NUMBER": "Number",
  "APPRAISER": "Appraiser",
  "AMOUNT": "Amount",
  "STATUS": "Status",
  "PAYMENT_INFORMATION": "Payment information",
  "CHECK": "Check",
  "DATE_PAID": "Date paid",
  "MODAL_MAKE_A_PAYMENT": "Make a payment",
  "PAY_BY_CHECK": "Pay by checking account",
  "PAY_BY_CREDIT_CARD": "Pay by credit/debit card",
  "SELECT_AMOUNT": "Select amount",
  "MINIMUM_AMOUNT_DUE": "Minimum Amt Due",
  "MINIMUM_AMOUNT_DUE_SMALL_CASE": "Min amount due",
  "AMOUNT_APPLIED": "Amt applied",
  "AMOUNT_APPLIED_FULL": "Amount applied",
  "DATE_APPLIED": "Date applied",
  "OUTSTANDING_POLICY_BALANCE": "Outstanding policy balance",
  "OTHER_AMOUNT": "Other amount",
  "ENTER_AMOUNT": "Enter amount",
  "CHECKING_ACCOUNT": "Checking account",
  "EDIT": "Edit",
  "ACCOUNT_HOLDER": "Account holder",
  "ACCOUNT_NUMBER": "Account number",
  "CHECK_NUMBER": "Check number (optional)",
  "PRIMARY_ACCOUNT_HOLDERS_NAME": "Primary Bank Account Holder's Name",
  "ACCOUNT_HOLDERS_NAME": "Account holder's name",
  "BANK_ROUTING_NUMBER": "Bank routing number",
  "CONFIRM_BANK_ACCOUNT_NUMBER": "Confirm bank account number",
  "STORE_INFORMATION": "Store this information for future one-time payments",
  "CHECK_NUMBER_OPTIONAL": "Check number (optional)",
  "PAYMENT_LEGAL": "I authorize Mapfre U.S.A. Corp. and its subsidiaries (“Mapfre”) to initiate the scheduled single entry deduction from the bank account identified above for payment of premium and any associated fees on the above identified insurance policy issued by Mapfre (the “Policy”); and to initiate credit entries to the account to correct any erroneous deductions. I understand that a fee may apply and be added to this withdrawal where permitted by law; and that a fee will be charged if payment is returned. I understand that my authorization for this transaction does not authorize Mapfre to make any future deductions from my account for the Policy without my consent. This single entry authorization will remain in effect until: (1) the payment is processed and the account is debited; or (2) Mapfre receives written notice from me of its termination, in such time and manner as to afford Mapfre a reasonable opportunity to act on it. *Mapfre U.S.A. Corp. and its subsidiaries, American Commerce Insurance Company (Columbus, OH); Citation Insurance Company (Webster, MA); The Commerce Insurance Company (Webster, MA); Commerce West Insurance Company (San Ramon, CA); and Mapfre Insurance Company (Florham Park, NJ).",
  "PAYMENT_LEGAL_ACMIC": "I authorize Auto Club Mapfre Insurance Company (the 'Company') to initiate scheduled deductions from the bank account identified above for payment of premium and any associated fees on the insurace policy issued to me by the Company, any subsequent replacement policy issued by the Company, and any renewals thereof (the \"Policy\"); and to initiate credit entries to the account to correct any erroneous deductions or provide a refund of premium. Further, I authorize and request that funds be withdrawn from the account as payments become due under the Policy. I understand the payment amount may vary as a result of changes to and/or renewal of the Policy. I understand that a fee may apply and be added to each withdrawal where permitted by law; and that a fee will be charged for all returned payments. This authorization will remain in effect until the Company receives writtern notice from me of its termination, in such time and manner as to afford the Company a reasonable opportunity to act on it. The company reserves the right to terminate this payment plan and/or my participation in it at any time.",
  "CONFIRM_PAYMENT": "Confirm payment",
  "MAILING_ADDRESS": "Mailing address",
  "HOLDER_NAME": "Holder name",
  "ROUTING_NUMBER": "Routing number",
  "BANK_ACCOUNT_NUMBER": "Bank account number",
  "PAYMENT_AMOUNT": "Payment amount",
  "REVIEW_PAYMENT": "Review payment",
  "MAKE_A_CHECK_PAYMENT": "Make a check payment",
  "BILLING_QUESTIONS": "Billing questions",
  "BILLING_REQUESTS": "Billing requests",
  "BILLING_REQUEST": "Billing request",
  "QUESTIONS_ABOUT_POLICY": "Have a question about this policy?",
  "CONTACT_BILLING_REP": "Contact your billing representative",
  "YOUR_EMAIL_ADDRESS": "Your email address",
  "YOUR_COMMENTS": "Your comments",
  "BILLING_PAR_ONE": "You cannot make changes to your policies or coverages using this sytem. For these concerns please contact your independent insurance agent.",
  "BILLING_PAR_TWO": "We can only respond to email inquiries from a named insured on this policy.",
  "MODAL_POLICY_NUMBER": "Policy number",
  "MODAL_BILL_REP": "Billing representative",
  "MODAL_BILLING_REP_HELP_TITLE": "Contact representative",
  "CONTACT_YOUR_BILLING_REP": "Contact your billing rep.",
  "SCHEDULED_PAYMENTS": "Scheduled bills",
  "HISTORY": "Billing history",
  "DUE_DATE": "Due date",
  "DATE": "Date",
  "BILLING_OVERVIEW": "Billing overview",
  "CUSTOMER_BALANCE": "Policy balance",
  "NO_PAYMENTS": "No payments due!",
  "ENROLL_IN_OUR_PAPERLESS_PLAN": "Enroll in our paperless plan",
  "AND_SAVE_UP_TO_3%": "Get paperless benefits!",
  "AND_GET_YOUR_DISCOUNT": "And get your discount",
  "YOUR_DISCOUNT_IS_APPLIED": "Your discount is applied",
  "SETTINGS": "Settings",
  "ADD_NEW_POLICY_TITLE": "Add policy",
  "PROVIDE_VALID_POLICY": "Please provide a valid policy number",
  "POLICY_ADDED_SUCCESSFULLY": "Policy succesfully added",
  "DASHBOARD_BUSINESS_POLICY_DETECTED": "We are working on it. Please contact our Customer Service Department for assistance.",
  "BUSINESS_POLICY_DETECTED_INFO": "We are working on it. Please contact our Customer Service Department for assistance.",
  "BUSINESS_POLICY_DETECTED": "Business policy detected.",
  "I_AM_AUTHORIZED": "I'm authorized",
  "POLICY_FOUND": "Policy found",
  "MAKE_A_PAYMENT": "Make a payment",
  "HAVE_OTHER_MAPFRE_POLICIES_NOT_LISTED_HERE": "Have other Mapfre policies not listed here?",
  "ADD_YOUR_POLICY": "Add policy number",
  "PAPERLESS_ONE": "Going paperless expedites the delivery of your documents and the posting of your payments as well as helps the environment!",
  "PAPERLESS_TWO": "No matter where you are, your billing and policy information is available through your online account. ",
  "PAPERLESS_THREE": "Combine paperless, autopay & e-Bill",
  "PAPERLESS_THREE-STRONG": "and get discounts!",
  "PAPERLESS_FOUR": "Let's enroll",
  "E-POLICY": "paperless",
  "E-PAY": "Autopay",
  "AUTOPAY_PAPERLESS": "Simplify your billing",
  "WHY_SHOULD_ENROLL": "Why should you enroll?",
  "AUTO_PAY_TITLE": "Autopay",
  "AUTOPAY_CONTENT": "Enroll in autopay and save time!",
  "AUTOPAY_CONTENT_SUB": "Use automatic payments to let us do the work for you based on your schedule. Pick a day and enroll now!",
  "PAPERLESS_CONTENT": "To receive the paperless discount, you’ll receive all of your documents and statements electronically. Helping us stay green earns you a 2% discount on your auto policy and/or a 3% discount on your homeowners policy.",
  "AUTO_PAY_SETTINGS": "Autopay settings",
  "NOT_AVAILABLE_FOR_YOUR_POLICY": "Not available for your policy (or policies)",
  "NOT_AVAILABLE_FOR_THIS_POLICY": "Not available for this policy",
  "NOT_AVAILABLE_FOR_AUTOPAY": "Not available for autopay",
  "E-BILL": "in E-bill",
  "PAPERLESS_SIX": "View your policy documents online.",
  "PAPERLESS_SEVEN": "View your bills online (past & present) for those policies not enrolled in e-Bill.",
  "ARE_YOU_SURE_YOU_WANT_TO_REMOVE_POLICY": "Are you sure you want to remove policy ",
  "FROM_E-POLICY": "from paperless?",
  "FROM_E-BILL": "from E-bill?",
  "FROM_E-PAY": "from autopay?",
  "PAPERLESS_NINE": "Remove from paperless",
  "PENDING_ENROLLMENT": "Enrollment pending",
  "PENDING_REMOVAL": "Removal pending",
  "UPDATE_PENDING": "Update pending",
  "REMOVE_FROM_E-POLICY": "Remove from paperless",
  "REMOVE_FROM_E-PAY": "Remove from autopay",
  "REMOVE_FROM_E-BILL": "Remove from e-Bill",
  "CONFIRM_ENROLLMENT": "Confirm enrollment",
  "PAPERLESS_EIGHT": "Set autopay. EPay - Electronic Funds Transfer (EFT) - and forget about payments.",
  "POLICIES_ELEGIBLE": "Policies eligible",
  "EPOLICY_ONE": "paperless allows you to view your documents online anytime.",
  "EPOLICY_TWO": "You will receive an email notification whenever a new document is available.",
  "EPOLICY_THREE": "Combine with autopay or e-BILL to get our paperless discount!",
  "ENROLLED_TEXT": "Enrolled in",
  "ENROLLED_ONLY": "Enrolled",
  "EPAY_ONE": "Autopay is our Electronic Funds Transfer (EFT) payment option.",
  "EPAY_TWO": "It is automatically done for you each month.",
  "EPAY_THREE": "Combine with paperless to get our paperless discount!",
  "EPAY_ENROLL_TITLE": "Autopay enrollment",
  "EPAY_CONFIRMATION_TITLE": "You are successfully enrolled in autopay",
  "ACIC_TW_EPAY_CONFIRMATION_TITLE": "Thank you for your request",
  "EPAY_ENROLL_PARA": "Add your checking or savings account to enroll your policy in autopay",
  "EPAY_ENROLL_PARA_NEW": "Add your checking or savings account and choose monthly deduction date to enroll your policy in autopay.",
  "CHECKING_SAVING_AUTOPAY_TW": "Add your checking or savings account to enroll your policy in autopay.",
  "DEBiT_CREDIT_CARD_AUTOPAY": "Add your credit/debit card to enroll your policy in autopay.",
  "EPAY_CONFIRM_ONE": "Your policy is now enrolled in autopay",
  "EPAY_CONFIRM_TWO": "Your autopay deduction schedule will be sent to you 2 weeks prior to your first deduction. Your account will reflect your updates within 1 to 2 business days.",
  "EPAY_CONFIRM_TWO_STRONG": "The estimated deduction may not include any increase or decrease in premiums due to the removal of discounts or policy changes.",
  "TYPE_OF_ACCOUNT": "Type of account",
  "ROUTING/AB": "Routing/ABA number",
  "BANK/ABA": "Bank/ABA Number",
  "MONTHLY_DEDUCTION_DATE": "Monthly deduction date",
  "MONTHLY_AUTOPAY_DEDUCTION_DATE": "Monthly Autopay deduction date",
  "UPDATE": "update",
  "ENROLL_TO_SEND_EBILL": "Enroll to send e-Bill",
  "EBILL_ONE": "Autopay is our Electronic Funds Transfer (EFT) payment option.",
  "EBILL_TWO": "It is automatically done for you each month.",
  "EBILL_THREE": "Combine with paperless to get our paperless discount!",
  "MODAL_E-BILL-ENROLL_TITLE": "E-BILL ENROLL",
  "MODAL_E-POLICY-ENROLL_TITLE": "PAPERLESS ENROLL",
  "MODAL_E-PAY-ENROLL_TITLE": "AUTOPAY ENROLL",
  "MODAL_E-POLICY-REMOVAL_TITLE": "PAPERLESS REMOVAL",
  "MODAL_E-PAY-REMOVAL_TITLE": "AUTOPAY REMOVAL",
  "MODAL_E-BILL-REMOVAL_TITLE": "E-BILL REMOVAL",
  "MODAL_REMOVAL_TITLE": "Unenroll from autopay",
  "MODAL_REMOVAL_TITLE_PAPERLESS": "REMOVE FROM PAPERLESS",
  "MODAL_ENROLL_TITLE": "ENROLL NOW",
  "PLEASE_CONFIRM_YOUR_REQUEST_TO_ENROLL_POLICY": "Please confirm your request to enroll policy ",
  "IN_E-POLICY": "in paperless",
  "IN_PAPERLESS": "in e-policy?",
  "IN_E-BILL": "in e-Bill?",
  "IN_E-PAY": "in autopay?",
  "PROFILE_CHECKING_ACCOUNT": "Updating your stored checking account will not update any information about your checking accounts on our e-Bill site.",
  "PROFILE_CHECKING_ACCOUNT_SAVE": "Save checking account",
  "PROFILE_CHECKING_ACCOUNT_MODAL_ONE": "If you go back you will lose all your progress.",
  "PROFILE_CHECKING_ACCOUNT_MODAL_TWO": "Are you sure that you want to remove all Checking account information?",
  "PROFILE_EMAIL_ONE": "Enter new email address",
  "PROFILE_EMAIL_TWO": "Change email address",
  "PROFILE_EMAIL_THREE": "First, enter your current password",
  "PROFILE_PASSWORD_TITLE": "Change your password",
  "PROFILE_PASSWORD_ONE": "Before you continue, verify your password",
  "PROFILE_PASSWORD_TWO": "Let's create your new password",
  "SEND_EMAIL_AGAIN": "Send email again",
  "YOUR_CURRENT_EMAIL_IS": "Email changes are reflected online immediately, however, please allow 24-48 hours for system processing.",
  "PROFILE_EMAIL_CONF_ONE": "Important",
  "PROFILE_EMAIL_CONF_TWO": "Please confirm that the new email is correct. After you confirm, the previous one will no longer be valid for logging into your account.",
  "PROFILE_EMAIL_CONF_THREE": "New email",
  "PROFILE_EMAIL_CONF_FOUR": "Confirm new email",
  "PROFILE_EMAIL_CONF_FIVE": "Check your spam for a message with the subject:",
  "PROFILE_MAIN_ONE": "Account and settings",
  "PROFILE_MAIN_TWO": "Change password",
  "PROFILE_MAIN_THREE": "Add more security to your account",
  "PROFILE_MAIN_FOUR": "Manage your checking/savings accounts",
  "PROFILE_MAIN_FIVE": "Save time making payments by securely storing your bank account information on each policy (non- autopay customers)",
  "PROFILE_MAIN_SIX": "Bank account ending in",
  "PROFILE_MAIN_SEVEN": "Your digital wallet",
  "PROFILE_MAIN_EIGHT": "Save time making payments by assigning an account to each policy (not autopay).",
  "PROFILE_CARDS": "Manage your credit and debit cards.",
  "PROFILE_PHONE_ONE": "Update phone number",
  "PROFILE_PHONE_TWO": "Add phone number",
  "PAYMENT_HISTORY": "Billing history",
  "PENDING_CHECKS": "Pending checks",
  "NO_DOCUMENTS_TITLE": "No documents available yet",
  "NO_DOCUMENTS_PARAGRAPH": "Your documents tab will list the available Coverage selection pages and allow you to view, print, and save them.",
  "SAVE_TIME_AND_MONEY": "Save time and money!",
  "NEW_AND_EXISTING_CLAIMS": "New and existing claims",
  "BILLING_CUSTOMER_SERVICE_QUOTES": "Customer service and other questions",
  "FOLLOW_US": "Follow us",
  "CONTACT_YOUR_AGENTS": "Contact your agents",
  "FOR_POLICY_CHANGES_COVERAGES_DISCOUTS": "For policy changes, coverages & discounts",
  "ACCOUNT_NUMBER_CONFIRM_DO_NOT_MATCH": "Bank account number and confirm bank account number does not match",
  "NOT_IN_A_VALID_FORMAT": "Your input is not in a valid format. example 111.11 or 111",
  "THIS_AMOUNT_IS_LESS_THAN_YOU_MIN": "Enter an amount greater than your minimum amount due – ",
  "THIS_AMOUNT_IS_GREATER_THAN_ONE": "Enter an amount greater than $1",
  "CHECKING_YOU_KNOW_THAT_AMOUNT_IS_LESS_THAN_MIN_AMOUNT": "By checking this, you recognize that the amount you are sending is less than the minimum amount due.",
  "LESS_THAN_MIN_AMOUNT": "The amount you are sending is less then the minimum amount due",
  "REMOVE_CHECKING_ACCOUNT": "Remove bank account",
  "DISCARD_CHANGES": "Discard changes",
  "STAY_HERE": "Stay here",
  "CONFIRM_EMAIL": "Confirm new email",
  "CONFIRM_CONTACT_DETAILS": "To ensure you receive important updates from Mapfre and to access your account login, please confirm your contact details",
  "LETS_VERIFY_YOUR_ACCOUNT": "Let's verify your account",
  "EMAIL_VERIFICATION_SUBJECT_TITLE": "We have sent an email with a verification link to:",
  "RESEND_VERIFICATION_EMAIL": "Resend verification email",
  "DID_NOT_RECEIVE_EMAIL": "Didn't receive the email?",
  "CHECK_YOUR_SPAM_MESSAGES": "Check your spam for a message with the subject",
  "CHECKING_ACCOUNT_INFO_UPDATED": "Checking account information succesfully updated",
  "ERROR_CHECKING_INFO": "There was a problem with updating your checking account information",
  "PLEASE_ENTER_VALID_ADDRESS": "Enter a Massachusetts address",
  "PLEASE_ENTER_VALID_ADDRESS_CA": "Enter a California address",
  "CHANGE_ADDRESS_ALERT_SUCCESS": "Your address change request was submitted.",
  "CHANGE_ADDRESS_ALERT_ERROR": "We cannot update the address.",
  "INVALID_CHANGE_PASSWORD": "Wrong password",
  "CANCELLED": "Cancelled",
  "SUBJECT_EMAIL": "Mapfre Insurance - Please activate your account",
  "UPDATE_MAILING_ADD": "Update mailing address",
  "AVAILABLE_24_7": "Always here for you 24/7",
  "BANK_ACCOUNT_HOLDER_NAME_VALIDATION": "Please enter a valid name.",
  "BANK_ROUTING_NUMBER_VALIDATION": "Please enter a valid routing number",
  "BANK_ACCOUNT_NUMBER_VALIDATION": "Please enter a valid bank account number",
  "NOT_ELEGIBLE": "Not eligible for paperless",
  "EPAY_ENROLL_LEGAL": "I authorize Mapfre U.S.A. Corp. and its subsidiaries* (“Mapfre”) to initiate scheduled deductions from the bank account identified above for payment of premium and any associated fees on the insurance policy issued to me by Mapfre, any subsequent replacement policy issued by Mapfre, and any renewals thereof (the “Policy”); and to initiate credit entries to the account to correct any erroneous deductions or provide a refund of premium. Further, I authorize and request that funds be withdrawn from the account as payments become due under the Policy. I understand the payment amount may vary as a result of changes to and/or renewal of the Policy. I understand that a fee may apply and be added to each withdrawal where permitted by law; and that a fee will be charged for all returned payments. This authorization will remain in effect until Mapfre receives written notice from me of its termination, in such time and manner as to afford Mapfre a reasonable opportunity to act on it. Mapfre reserves the right to terminate this payment plan and/or my participation in it at any time. * Mapfre U.S.A. Corp. and its subsidiaries, American Commerce Insurance Company (Columbus, OH); Citation Insurance Company (Webster, MA); The Commerce Insurance Company (Webster, MA); Commerce West Insurance Company (San Ramon, CA) and Mapfre Insurance Company (Florham Park, NJ).",
  "CCDC_TERMS_CONDITIONS": "I authorize Mapfre U.S.A. Corp. and its subsidiaries* (“Mapfre”) to initiate scheduled deductions from my selected card for payment of premium and any associated fees on the insurance policy issued to me by Mapfre, any subsequent replacement policy issued by Mapfre, and any renewals thereof (the ”Policy”); and to provide a refund of premium to correct any erroneous deductions. Further, I authorize and request that funds be withdrawn from the card as zents become due under the Policy. I understand the payment amount may vary as a result of changes to and/or renewal of the Policy. I understand that a fee may apply and be added to each withdrawal where permitted by law; and that a fee will be charged for all returned payments. This authorization will remain in effect until Mapfre receives written notice from me of its termination, in such time and manner as to afford Mapfre a reasonable opportunity to act on it. Mapfre reserves the right to terminate this payment plan and/or my participation in it at any time. *Mapfre U.S.A. corp. and its subsidiaries, American Commerce insurance Company (Columbus, OH); Citation Insurance Company (Webster, MA); The Commerce Insurance Company (Webster, MA); Commerce West Insurance Company (San Ramon, CA) and Mapfre Insurance Company (Florham Park, NJ).",
  "POLICY_NOT_FOUND": "Policy not found",
  "NOT_ELEGIBLE_EPOLICY": "Not eligible for paperless",
  "NOT_ELEGIBLE_EPAY": "Not eligible for autopay",
  "NOT_ELEGIBLE_EBILL": "e-Bill not available for this policy.",
  "ALWAYS_HERE_FOR_YOU": "Always here for you 24/7",
  "CONTACT_CENTER_HOURS": "Monday to Friday 7am to 9pm",
  "CONTACT_CENTER_HOURS_2": "Saturday 8am to 5pm",
  "VALID_ACCOUNT_NUMBER": "Please enter a valid bank account.",
  "VALID_ROUTING_NUMBER": "Please enter a valid routing number",
  "VALID_CONFIRM_BANK_ACCOUNT_NUMBER": "Please make sure your input matches the above account input",
  "VALID_ADDRESS": "Please make sure you use one of Google's recomendation.",
  "VALID_PHONE_NUMBER": "Incorrect phone format",
  "WAYS_TO_SAVE": "Ways to save",
  "MA_AUTO_INSURANCE_POLICY": "Massachusetts Automobile Insurance Policy",
  "TO_MAIL_A_PAYMENT_OR_CORRESPONDENCE": "To mail a payment or correspondence",
  "ENTER_COMPANY_NAME": "Enter the Company name exactly as it appears on your Mapfre policy documents.",
  "COMPANY_NAME": "Mapfre Insurance",
  "POBOX": "PO Box ",
  "POBOX_1": "PO Box 970007,",
  "POBOX_2": "Boston, MA 02297",
  "POBOX_3": "P.O. Box 35931",
  "POBOX_4": "P.O. Box 52234",
  "POBOX_5": "Phoenix, AZ 85072",
  "PAYMENT_TITLE": "Payment",
  "CORRESPONDENCE_TITLE": "Correspondence",
  "ADDRESS_PART_ONE": "11 Gore Road",
  "ADDRESS_PART_TWO": "Cleveland, OH 44135",
  "THE_BILLS_FOR_YOUR_POLICY": "The bills for your policy are mailed to your mortgagee.",
  "THANKS_FOR_UPDATING_YOUR_ODOMETER": "Thanks for updating your odometer.",
  "BILLING_CONFIRM_ONE": "Congrats! You've paid your bill and saved your bank information!",
  "BILLING_CONFIRM_THREE": "There was a problem paying your bill, please review your details.",
  "NAME_AS_PASSWORD_ERROR": "Password cannot include your name.",
  "FIRST_NAME_AS_PASSWORD_ERROR": "Password cannot include your name.",
  "LAST_NAME_AS_PASSWORD_ERROR": "Password cannot include your name.",
  "LAST_PAYMENT_RECEIVED": "Last payment received",
  "TOO_MANY_IDENTICAL_CHARACTER": "Too many identical characters in your password.",
  "GREATER_THAN_MIN_AMOUNT": "Greater than minimum amount",
  "NOT_YOU": "Not you?",
  "GOOD_MORNING": "Good morning",
  "GOOD_AFTERNOON": "Good afternoon",
  "GOOD_EVENING": "Good evening",
  "THIS_AMOUNT_IS_GREATER_THAN_OUTSTANDING": "Enter an amount equal or smaller than your balance -",
  "PAYMENT_METHOD": "Payment method",
  "POLICY_LINKED_TO_ANOTHER_EMAIL": "Policy linked to another email",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_DISCRIPTION": "Please review your details or contact us to fix your email issues.",
  "REVIEW_DETAILS_LINK": "Review your details",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_PERSONAL_ASSISTANCE": "If you need personal assistance, contact our Customer Service Department by calling",
  "POLICY_LINKED_TO_ANOTHER_EMAIL_SEND_US_EMAIL": "sending us an email.",
  "POLICY_LINKED_TO_ANOTHER_FOR_OR": "or",
  "YOUR_PERSONAL_AUTO_POLICY_RENEWAL": "Your personal auto policy renewal",
  "FORGOT_PASSWORD_SUCCESSFULLY": "Your new password has been created.",
  "MILEAGE": "Odometer",
  "AUTO_PAY": "Autopay",
  "MORTGAGE_BILLED": "mortgagee billed",
  "UPDATE_ADDRESS": "Update address",
  "NUMBER_AND_STREET": "Enter your address then select from the list",
  "CONTACT_YOUR_BILLING_REPRESENTATIVE": "Contact your billing representative",
  "PAYMENT_SUCCESS": "Thank you for your payment.",
  "NEW_PARKING_LOCATION_INFO": "This change will be refered for further review.",
  "WELCOME_FIRST_TIME": "Welcome to your Mapfre Insurance account!",
  "ENTER_YOUR_CURRENT_PASSWORD": "Current password",
  "ENTER_A_VALID_PASSWORD": "Enter a valid password",
  "CONFIRM_BUTTON": "Confirm",
  "CHANGE_PASSWORD_BUTTON": "Change password",
  "SAVE_TIME_EACH_MONTH": "Save time each month",
  "EMAIL_IN_USE": "Email is already in use",
  "EMAIL_MISMATCH": "Email does not match",
  "EMAIL_UPDATE_SUCCESSFUL": "Your email was successfully updated",
  "ADD_CHECKING_SAVING_ACCOUNT": "Add checking/savings account",
  "UPDATE_CHECKING_SAVING_ACCOUNT": "Change your checking/savings account",
  "ADD_ACCOUNT": "Add account",
  "UPDATE_ACCOUNT": "Update account",
  "REMOVE_CHECKING_ACCOUNT_MSG_1": "Are you sure you want to remove your checking/savings account",
  "REMOVE_CHECKING_ACCOUNT_MSG_2": "from your account?",
  "REVIEW_POLICY_UPDATES_CHANGES": "Review your policy for any updates or changes.",
  "KEEP_BANK_ACCOUNT": "Keep bank account",
  "BANK_ACCOUNT_REMOVED": "Bank account removed successfully",
  "BANK_ACCOUNT_ADDED": "Bank account successfully added!",
  "BANK_ACCOUNT_UPDATED": "Bank account successfully updated!",
  "EMAIL_EBILL": "Email to receive messages",
  "POLICY_ADDEDD_SUCCESSFULLY": "Policy successfully added!",
  "POLICY_ADDITION_ERROR": "Policy not addedd",
  "EMAIL_SUCCESSFULLY_CHANGED": "Email successfully changed.",
  "ENROLL": "Enroll",
  "UNENROLL": "Unenroll",
  "UNENROLL_DISCUSS_OPTION": "To discuss your options, Customer Service department to enroll ",
  "DEDUCTION_DATE_MESSAGE": "You can only edit the date 3 times in a policy term.",
  "PHONE_ADDED_SUCCESSFULLY": "Phone number successfully added",
  "PHONE_UPDATED_SUCCESSFULLY": "Phone number successfully updated",
  "ADD_PHONE_BUTTON": "Add phone number",
  "UPDATE_PHONE_BUTTON": "Update phone",
  "CONTACT_YOUR_AGENT": "Contact your agent",
  "SEE_OUR_HELP_SECTION": "See our help section",
  "CLAIM_FAQ_5B": "to learn more.",
  "FULLY_ENROLLED_IN_PAPERLESS": "You are fully enrolled in paperless.",
  "NO_POLICIES_ELIGIBLE": "You do not have any policies eligible for paperless",
  "BANK_ACCOUNT_HOLDER": "Bank account holder’s name",
  "BANK_ACCOUNT_HOLDERS_NAME": "Bank account holder’s name",
  "ROUTING_ABA_NUMBER": "Routing/ABA number",
  "VIEW": "View",
  "VIEW_TRANSACTIONS": "View transactions",
  "TERMS_AND_CONDITIONS": "I have read and agreed to the terms below.",
  "PLEASE_CONFIRM": "Please confirm",
  "CONFIRM_LANGUAGE": "Confirm language",
  "CLAIM_INFO": "For \"collision\" losses, a surcharge may apply depending on who is responsible for the accident.",
  "EBILL_ENROLL": "You have enrolled in e-Bill. It may take up to 2 days to process.",
  "EBILL_CANCEL": "You have canceled e-Bill. It may take up to 2 days to process.",
  "EPAY_ENROLL": "Congrats! You've enrolled!",
  "UPDATE_EPAY_ENROLL": "Autopay successfully updated!",
  "EPAY_CANCEL": "You have canceled autopay. It may take up to 2 days to process.",
  "EPAY_ENROLL_ERROR": "Sorry, there was an issue and we could not enroll you.",
  "EPOLICY_ENROLL": "You have enrolled in paperless. It may take up to 2 days to process.",
  "EPOLICY_CANCEL": "You have canceled paperless. It may take up to 2 days to process.",
  "PROBLEM_IN_REQUEST_PROCESSING": "There was a problem processing your request. Please try again later.",
  "VERIFICATION_EMAIL_SENT": "Verification email sent.",
  "VERIFICATION_EMAIL_ERROR": "There was a problem to send verification email.",
  "MILEAGE_MAX_LIMIT": "Please enter a value less than 1000000.",
  "VALUE_LESS_THAN_ORIGINAL": "The value you have input is less than the original.",
  "PLEASE_UPDATE_MILEAGE": "Please update the odometer.",
  "PROBLEM_UPDATING_MILEAGE": "There was a problem updating your odometer.",
  "CLAIM_DETAIL_TOOLTIP": "For \"collision\" losses, a surcharge may apply depending on who is responsible for the accident.",
  "HOME": "Home",
  "CONTACT_US": "Contact us",
  "BAD_REQUEST": "Bad request",
  "ERROR_400": "The link you clicked may be broken, or the page may have been removed",
  "AUTHORIZATION_NEEDED": "Authorization needed",
  "ERROR_401": "Sorry, we couldn’t verify that you are authorized to access this page.",
  "FORBIDDEN": "Forbidden",
  "ERROR_403": "Sorry, you don’t have permission to access this page.",
  "PAGE_NOT_FOUND": "Page not found",
  "ERROR_404": "The link you clicked may be broken, or the page may have been removed.",
  "REQUEST_TIMED_OUT": "Request timed out",
  "ERROR_408": "This page took too long to load.",
  "GONE": "gone",
  "ERROR_410": "The link you clicked may be broken, or the page may have been removed.",
  "INTERNAL_SERVER_ERROR": "Internal server error",
  "ERROR_500": "Sorry, the server encountered an error and couldn’t complete your request.",
  "BAD_GATEWAY": "Bad gateway",
  "ERROR_502": "Sorry, we encountered a temporary error. Please try again.",
  "TEMPORARILY_UNAVAILABLE": "Temporarily unavailable",
  "ERROR_503": "Sorry, we encountered a temporary error. Please try again.",
  "GATEWAY_TIMEOUT": "Gateway timeout",
  "ERROR_504": "Sorry, we encountered a temporary error. Please try again.",
  "CHECKING": "Checking",
  "SAVING": "Savings",
  "SAVING_ACCOUNT": "Savings account",
  "DATE_BILLED": "Date billed",
  "ROUTING_NUMBER_VALIDATION": "Provide a valid routing number.",
  "EPAY_EDIT_ENROLL_PARA": "We need up to 15 days in order to process the changes requested.",
  "THANKS_FOR_VALIDATING_ACCOUNT": "Thank you for validating your account!",
  "YES": "YES",
  "NO": "NO",
  "NO_POLICY_IN_PAPERLESS": "You do not have any policies eligible for paperless.",
  "THIS_VEHICLE_IS_NOT_ELIGIBLE": "Odometer update is not available",
  "UMBRELLA": "Umbrella",
  "SCHEDULED_PROPERTY": "Scheduled Property",
  "GARAGE_KEEPER": "Garage Keeper",
  "DWELLING_FIRE_PERSONAL": "Dwelling Fire Personal",
  "GENERAL_LIABILITY": "General Liability",
  "COMMERCIAL_AUTO": "Commercial Auto",
  "SPECIAL_MULTI_PERIL": "Special Multi Peril",
  "COMMERCIAL_FIRE": "Commercial Fire",
  "CLASSIC_FORMAT": "Classic Format",
  "NEW_FORMAT": "New Format",
  "MAKE_PAYMENT_ONLINE": "Would you still like to make a payment online?",
  "AUTO_PAYMENT_HELP_TEXT": "There is an automatic payment scheduled for",
  "CANNOT_BE_STOPPED": "which cannot be stopped.",
  "AUTO_PAYMENT_HELP_TEXT_FOR_STOP": "An automatic payment is scheduled for",
  "HELP_TEXT_TO_STOP_PAYMENT": "If you make a manual payment now, the automatic payment will be adjusted to reflect the amount paid online.",
  "ENROLL_IN_PROGRAM": "Enroll in our paperless program!",
  "YOUR_POLICIES": "Your policies",
  "PAPERLESS_DISCOUNT_AVAILABLE": "Paperless discount available!",
  "PAST_POLICIES": "Past policies",
  "POLICIES": "Policies",
  "REMOVE_POLICY_FROM_PAPERLESS": "You are about to remove your policy from paperless. Are you sure you want to continue?",
  "REMOVE_POLICY_FROM_EBILL": "You are about to remove your policy from e-bill. Are you sure you want to continue?",
  "REMOVE_POLICY": "Remove",
  "MANAGE_PAYMENT_METHOD": "Manage payment methods",
  "MANAGE": "Manage",
  "AUTOPAY_TEXT": "Set up autopay and forget about payments.",
  "AUTOPAY_ENROLL_TITLE": "Autopay enrollment",
  "AUTOPAY_EDIT_TITLE": "Edit autopay information",
  "FROM_AUTOPAY": "from autopay?",
  "REMOVE_FROM_AUTOPAY": "Remove from autopay",
  "RESIDENTIAL_ADDRESS_TEXT": "Changing your residential address will update where your vehicle is garaged and may change your policy premium. If any vehicle covered under this policy is garaged at a different location, ",
  "CONTACT_AGENT": "contact your agent.",
  "YOUR_RENEWAL_INFORMATION": "Your renewal information",
  "RENEWAL_HAPPENING_SOON": "Your renewal is happening soon!",
  "THANK_YOU_FOR_CONTINUING_TO_TRUST_US": "Thank you for continuing to trust us. We appreciate your loyalty.",
  "ANOTHER": "Another",
  "POLICY_TERM": "policy term",
  "RENEWAL_NOTIFICATION_TEXT_1": "has passed and now is the time to take a look at your renewal to see if anything needs to be updated, changed or removed. Please do not hesitate to",
  "POLICY_ABOUT_TO_RENEW": "Policy about to renew",
  "VIEW_RENEWAL_DOCUMENTS": "View renewal documents",
  "CHECKING_SAVING_SUB_HEADING": "Will replace your existing account",
  "RENEWAL_TEXT_ONE": "In order to continue providing excellent service, we are migrating to a new system. During this time, you can still make payments. However, if you want to modify your policy details, please ",
  "RENEWAL_INFO_CONTACT_YOUR_AGENT": "contact your agent",
  "RENEWAL_INFO_NEW_CONTACT_YOUR_AGENT": "contact your agent",
  "RENEWAL_NOTIFICATION_TEXT_2": " to review your coverages as well as look for bundle and discount opportunities.",
  "RENEWAL_TEXT_TWO": "Also, your policy number will be updated. See below your new number, renewal details and documents.",
  "CURRENT_NUMBER": "Current number",
  "RENEWAL_TEXT_THREE": "During the migration process , your policy number will be updated",
  "NEW": "New",
  "PROCESSING_BALANCE": "Processing your current balance. Payments are disabled for 24 hours.",
  "PROCESSING_CHANGES": "We're processing your changes.",
  "BALANCE_SYNC": "Your prior and renewal balances have been synchronized. If you had a prior balance, this will appear under your new renewed policy. You can now view billing details and make payments.",
  "POLICY_UNDER_RENOVATION_MSG": "Policy renewal in progress. Online changes are not allowed during this time. Please ",
  "BILLING_AVAILABILITY": "Under Renewal. Billing will be available by",
  "PROCESSING_BILLING_BALANCE_1": "Processing your current balance for policy",
  "PROCESSING_BILLING_BALANCE_2": " Payments for this policy are disabled for 24 hours.",
  "PRIOR_RENEWAL_BALANCE_SYNC_1": "Your prior and renewal balance have been transferred for your policy",
  "PRIOR_RENEWAL_BALANCE_SYNC_PLURAL_1": "Your prior and renewal balance have been transferred for your policies",
  "PRIOR_RENEWAL_BALANCE_SYNC_2": "If you had prior pending balance this will appear under your new renewed policy. You can now view billing details and make payments.",
  "AND": "and",
  "DEDUCTION_DATE_RENEWAL": "Not available during renewal time.",
  "CHANGE_ADDRESS_ALERT_SUCCESS_FOR_LIVO": "Residential address successfully updated!",
  "PENDING_BALANCE": "Includes pending balance from previous term:",
  "PROCESSING_YOUR_REQUEST": "Processing your request",
  "TAKE_A_MINUTE": "This might take a minute.",
  "CLOSE_WINDOW": "Don't close this window",
  "PAPERLESS_CONFIRM_TEXT": "Your policy is not enrolled in paperless. Do you want to enroll now?",
  "EBILL_CONFIRM_TEXT": "Your policy is not enrolled in e-bill. Do you want to enroll now?",
  "PAPERLESS_CONFIRM_BUTTON_TEXT": "YES, enroll now",
  "PAPERLESS_MODEL_TITLE": "Please confirm",
  "LINK_EXPIRED_FORGOT_PASS": "Forgot password?",
  "LINK_EXPIRED": "Link has expired",
  "LINK_EXPIRED_TEXT": "You already used this link to activate your account or retrieve your password.",
  "EXPIRED_POLICY_LEGAL_MESSAGE": "This policy is canceled, payment of the balance owed to us will NOT reinstate this policy. To request reinstatement, you may contact your agent or our Customer Service Department at",
  "VIEW_e-BILL": "View e-BILLs",
  "LOG_INTO_ACCOUNT": "Log into your account",
  "CONTACT_US_AT": "Please contact us at ",
  "SINGLE_POLICY": "For any inquiry about the following policy:",
  "MULTIPLE_POLICY": "For any inquiries about the following policies:",
  "FAQ": "FAQ: ",
  "FAQ_MSG": "Learn more in the ",
  "CLAIM_AREA": "claims area",
  "REMOVE_ACCOUNT_MSG": "To remove your checking/savings account, please contact our ",
  "CUSTOMER_SERVICE": "Customer Service Department",
  "ONLY_FOR_LIVO": "Digital wallet is only available for the following policies:",
  "AT_RENEWAL_TIME": "This functionality will be added to the rest of your policies at renewal time.",
  "FILE_CLIAM_FOR": "Please select the policy you want to file a claim for:",
  "APPRAISAL_MSG_HOME": "A licensed adjuster will be assigned to view your property and write an estimate for any accident related damage. Typically, the estimate is received within 5 business days from the day the property is seen by a licensed adjuster. This estimate will be mailed to you once it is completed.",
  "ATTORNEY_MSG": "Our records indicate that you are represented by an attorney for this claim. Your legal representative will receive all records, correspondence, and documents pertinent to your claim. Please contact your legal representative to inquire on the specifics of your claim.",
  "ATTORNEY": "Represented by attorney",
  "EBILL_NOT_AVAILABLE": "Not available for policy already enrolled in autopay.",
  "PAPERLESS_INFO_BLOCK": "To become paperless for the following policies (until they get renewed and convert to our new system) you have to enroll in e-Policy and e-Bill separately. Enroll in e-Policy to view your policy documents and e-Bill to view you past and present bills online.",
  "PASSWORD_RESET_CONFIRM": "Make sure the email you entered is the same one you created your Mapfre online account with.",
  "AFFINITY_PAYPLAN_BILLING": "Please contact your agent with any billing question.",
  "PO_BOX_ADDRESS": "PO Box address",
  "ENTER_VALID_ZIPCODE": "Enter a valid ZIP code",
  "OPTIONAL": "Optional",
  "OPTION_NOT_AVAILABLE": "This option is not available",
  "CREATE_COMMERCIAL_POLICY_ACCOUNT": "Create Commercial account",
  "COMPANY_NAME_LABEL": "Company name",
  "CREATE_COMMERCIAL_ACCOUNT": "Create Account For Commercial Policy",
  "EXACTLY_APPEARS_ON_INVOICE_LINK": "Exactly as it appears on your Mapfre Invoice",
  "REVIEW_COMPANY_NAME": "Review your company name",
  "CURR_AMT_DUE": "Current min amount due",
  "SEND_QUESTION": "Send question",
  "SEND_REQUESTS": "Send a request",
  "BILLING_QUESTION": "Have a billing question?",
  "SUBMIT_QUESTION": "Submit question",
  "SUBMIT": "Submit",
  "SEND_BILLING_QUESTION": "Send billing question",
  "BILLING_COMMENT_THANKS_FOR_REQUEST": "Thanks for your request",
  "BILLING_COMMENT_PARAGRAPH_ONE": "A copy of your request has been sent to your email",
  "COPY_TO_YOUR_EMAIL": "A copy has been sent to your email:",
  "BILLING_COMMENT_PARAGRAPH_TWO": "Please check your email within 48 business hours for a reply from our billing team.",
  "BILLING_COMMENT_REQUEST_SUBMIT_PROBLEM": "There was a problem submitting your request",
  "PLEASE_TRY_AGAIN": "Please try again",
  "BILLING_COMMENT_CONTACT_BILLING": "If the problem persists, please contact our billing department at",
  "GW_POLICY_BILLING_CONTACT": "855-627-3737",
  "AS400_POLICY_BILLING_CONTACT": "800-922-8276",
  "BANK_ACCOUNT_INFO_UPDATE_MESSAGE": "To change bank account information, please make a payment of at least $1.00.",
  "BILLING_QUESTION_INFO": "Our billing team is here to help! We'll answer your question within 48 business hours.",
  "BILLING_QUESTION_INFO_2": "If you have policy questions or changes, please ",
  "UPDATE_ODOMETER": "Update odometer",
  "REQUEST_UPDATE_MILEAGE": "Update mileage",
  "MILEAGE_DISCOUNT_1": "How often do you need to update your odometer? ",
  "MILEAGE_DISCOUNT_2": "You only need to update your odometer once a year, preferably before your next policy renewal.",
  "MILEAGE_DISCOUNT_3": "We will process your request and update your vehicle mileage within 5 business days.",
  "MILEAGE_UPDATE_SUCCESSFUL": "Mileage information received! Please allow us up to 5 business days to check and update your request.",
  "ODOMETER_UPDATE_ACTIVE_ONLY": "Update mileage is only available for active policies",
  "FILTER": "Filter",
  "BILLING_CONDITIONS": "*Amounts displayed may not reflect all recent policy changes or payments. **May not include all fees.",
  "E-BILL_TEXT": "E-bill",
  "NOT_ENROLLED_TEXT": "Enroll in",
  "CLAIMS_MAINTENANCE": "Sorry, claims system currently under maintenance.",
  "BILLING_MAINTENANCE": "Sorry, billing system currently under maintenance.",
  "DOCUMENT_MAINTENANCE": "Sorry, documents system currently under maintenance.",
  "MAINTENANCE_INPROGRESS": "We’re working to improve your online experience. Thanks for your patience while we make these updates.",
  "MAINTENANCE_TIME": "We’ll be back online in a few hours.",
  "SERVICE_UNDER_MAINTENANCE": "Sorry, service currently under maintenance.",
  "SYSTEM_DOWN_MAINTENANCE": "Sorry, system currently down for maintenance.",
  "MAINTENANCE_ASSISTANCE": "If you need our assistance,",
  "MAINTENANCE_CLAIMS": "Sorry, claims system currently under maintenance.",
  "MAINTENANCE_BILLING": "Sorry, billing system currently under maintenance.",
  "MAINTENANCE_DOCUMENT": "Sorry, documents system currently under maintenance.",
  "MAINTENANCE_INPROGRESS_1": "We’re working to improve your online experience.",
  "MAINTENANCE_INPROGRESS_2": "Thanks for your patience while we make these updates.",
  "AUTOPAY_CONTENT_1": "Enroll in autopay today. Let us do the work for you.",
  "AUTOPAY_CONTENT_2": "Just add a checking or savings account to enroll.",
  "ENTER_YOUR_EMAIL": "Enter your email",
  "EMAIL_TO_LOGIN_ACCOUNT": "Email is used to login to your account. We’ll send you an email with a validation link.",
  "CODE_EXPIRED": "Code expired",
  "SEND_NEW_CODE": "We can send you a new code to:",
  "CUSTOMER_SERVICE_DEPARTMENT": "If you don’t find or receive the code contact our Customer Service department.",
  "SECURITY_CODE_MOBILE_PHONE": "We have sent a text message with a security code to the following mobile phone:",
  "ENTER_CODE": "Enter code",
  "OUR_CUSTOMER_SERVICE_DEPARTMENT": "or contact our Customer Service department.",
  "FIND_OR_RECEIVE_CODE": "If you don’t find or receive the code",
  "REVIEW_AND_UPDATE": "The information entered doesn’t match our records",
  "DATA_OF_BIRTH": "Date of birth",
  "INFORMATION_IS_CORRECT": "If your information is correct, please try again. If you still have trouble, please contact our Customer Service department.",
  "VALIDATE_YOUR_ACCOUNT": "Validate your Account",
  "SEND_VALIDATION_EMAIL": "Send validation email again",
  "USE_OTHER_METHOD": "Use other method",
  "OR_CONTACT_OUR_CUSTOMER_SERVICE": "or contact our Customer Service department.",
  "VALIDATE_WITH_EMAIL": "Validate with email",
  "EMAIL_IS_ASSOCIATED_WITH_YOUR_POLICY": "The following email is associated with your policy.",
  "CONFIRM_EMAIL_TO_FINISH_ACCOUNT_SETUP": "Confirm the email to finish your account set up.",
  "IF_YOU_DONT_RECOGNIZE_THE_EMAIL_CONTACT_CUST_SER_DEPT": "If you don’t recognize the email, please contact our Customer Service Department.",
  "TEXT_MESSAGE_CHARGES": "* Text message charges might be applied.",
  "WHERE_CAN_I_FIND_POLICY_INFO": "Where can I find my policy information?",
  "VALIDATE_WITH_PHONE": "Validate with phone",
  "THIS_EMAIL_WILL_BE_USED_TO_LOGIN_YOUR_ACCT": "This email will be used to login to your account. We will send you an email with a validation link to complete the set up of your account.",
  "WE_HAVE_SENT_YOU_NEW_CODE": "New security code sent.",
  "SEND_NEW_CODE_CAPITAL_CASE": "Send new code",
  "DIDNT_RECEIVE_CODE": "Didn’t receive the code?",
  "SEND_NEW_CODE_TO_MY_PHONE_SMALL_CASE": "Send new code to my phone",
  "THE_FOLLOWING_PHONE_NUMBER_IS_ASSOCIATED_WITH_POLICY": "The following phone number is associated with your policy. Confirm the phone number to receive a text message with a security code.",
  "SEND_CODE": "Send code",
  "DONT_RECOGNIZE_PHONE_NUMBER_ABOVE_OR": "If you don’t recognize the phone number or if it is not a mobile phone number, please contact our Customer Service Department.",
  "I_OWN_THAT_EMAIL": "I own that email",
  "ENTER_YOUR_INFORMATION_AS_IT_APPEARS": "Enter your information as it appears on your policy documents.",
  "VALIDATE_YOUR_EMAIL": "Validate your email",
  "DONT_RECOGNIZE_THE_EMAIL": "Don’t recognize the email above?",
  "CONTINUE_CAPITAL_CASE": "Continue",
  "USE_MOBILE_PHONE": "Use mobile phone",
  "WE_HAVE_SENT_AN_EMAIL_WITH_LINK": "We have sent an email with a link to validate your account to:",
  "MAKE_SURE_TO_REVIEW_YOUR_SPAN_FOLDER": "Make sure to review your SPAM folder.",
  "USE_OTHER_EMAIL": "Use other email",
  "VALID_DOB_VALIDATION_MESSAGE": "Please enter a valid Date of Birth",
  "MAX_ATTEMPTS": "You have reached the maximum number of attempts and for security reasons we need you to contact our Customer Service department to create your account.",
  "PROBLEM_SENDING_OTP": "There was a problem sending OTP to your mobile phone",
  "PASSWORD_CREATED_PLEASE_LOGIN": "Password created, please login.",
  "LINK_EXPIRED_EMAIL": "Link expired",
  "WE_CAN_SEND_YOU_VALIDATION_EMAIL": "We can send you a new validation email to:",
  "SEND_NEW_EMAIL": "Send new email",
  "IF_YOU_DONT_RECEIVE_EMAIL_CONTACT_CUS_CARE": "If you don't receive the email, contact our Customer Service department at 1-855-627-3737.",
  "OTP_VALIDATION_MESSAGE": "Please enter security code",
  "CREATE_YOUR_PASSWORD": "Create your password",
  "SET_PASSWORD": "Set password",
  "CODE_EXPIRED_OR_INVALID": "Code expired/invalid",
  "DOB": "Date of birth",
  "POLICY_NUMBER_SIGNUP": "Policy number",
  "DIDNT_RECEIVE_EMAIL": "Didn’t receive the email?",
  "1_855_627_3737": "1-855-627-3737",
  "EXISTING_ACCT": "Existing account",
  "OUR_RECORDS_INDICATE_ALREADY_CREATED_ONLINE_ACCT": "Our records indicate you have already created an account with the email shown below:",
  "PLEASE_CONFIRM_INFORMATION_ENTERED_CORRECTLY": "Please confirm the information was entered correctly or contact our Customer Service Department at",
  "MAKE_A_PAYMENT_WITH": "Make a payment with",
  "ENTER_VALID_POLICY_NUMBER_MESSAGE": "Enter a valid policy number",
  "ENTER_VALID_DOB_VALIDATION_MESSAGE": "Enter a valid date of birth mm/dd/yyyy",
  "MAKE_A_PAYMENT_GUEST": "Make a payment",
  "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES": "Search in your policy documents or invoices.",
  "LOCATE_YOUR_POLICY_INFORMATION": "Locate your policy information",
  "IF_YOU_RECOGNIZE_THIS_EMAIL_LOG_YOUR_ACCT": "If you recognize this email, log into your account.",
  "THE_INFORMATION_ENTERED_DOESNT_MATCH": "The information entered doesn’t match our records",
  "NEW_VERIFICATION_EMAIL_SENT": "We have sent you a new validation email.",
  "CONTACT_CENTER_HOURS_ACMIC": "Monday to Friday 8am to 6pm PT",
  "CONTACT_CENTER_HOURS_2_ACMIC": "Saturday 6am to 12pm PT",
  "CUSTOMER_SERVICE_NUMBER": "1-855-627-3737",
  "ACCESS_CUSTOMER_PORTAL_VIEW_BILLING": "Access the Mapfre Customer Portal to view billing and policy information, enroll in autopay and more.",
  "NO_POLICIES_FOR_GIVEN_EMAIL": "No Massachusetts policies were found for the given email.",
  "MIDDLE_NAME_AS_PASSWORD_ERROR": "Password cannot include your name.",
  "OUR_CUSTOMER_SER_DEPT_HELP": "Our Customer Service Department is available to help.",
  "CUSTOMER_LOGIN": "Customer log in",
  "MANAGE_YOUR_MAPFRE_ACCOUNT_SET_UP": "Manage your Mapfre account, set up autopay, paperless, payments, claims, and much more",
  "REQUIRED_INQUIRY_TEXT": "required inquiry text",
  "INQUIRY_TOPIC_NOT_SELECTED": "inquiry topic not selected",
  "POLICY_NOT_SELECTED": "policy not selected",
  "BILLING_QUESTION_ERROR": "billing question error",
  "ADD_POLICY_ERROR": "add policy error",
  "VERIFY_POLICY_ERROR": "verify policy error",
  "CHANGE_PASSWORD_ERROR": "change password error",
  "ACCOUNT_EXISTS": "account exists",
  "INCORRECT_USER_DETAILS": "incorrect user details",
  "REGISTRATION_ERROR": "registration error",
  "UPDATE_PASSWORD_ERROR": "update password error",
  "CREATE_PASSWORD_ERROR": "create password error",
  "EDIT_POLICY_ERROR": "edit policy error",
  "ACCCOUNT_AND_CONFIRM_NUMBER_MATCH": "account number and confirmation are not the same",
  "ENROLL_ERROR": "enroll error",
  "LOGIN_ERROR_LOCKED": "login error | account locked",
  "LOGIN_ERROR_INVALID_EMAIL_PASSWORD": "login error | invalid email/password combination",
  "LOGIN_ERROR": "login error",
  "MAKE_PAYMENT_ERROR": "make payment error",
  "NEWPAYMENT_ACCCOUNT_AND_CONFIRM_NUMBER_MATCH": "new payment account number and confirmation are not the same",
  "CHECKING_ACCOUNT_ACCCOUNT_AND_CONFIRM_NUMBER_MATCH": "checking account form account number and confirmation are not the same",
  "ADDRESS_UPDATE_ERROR": "address update error",
  "INVALID_ADDRESS": "invalid address",
  "PHONE_NUMBER_UPDATE_ERROR": "phone number update error",
  "CHECKING_ACCOUNT_ERROR": "checking account error",
  "UPDATE_EMAIL_ERROR": "update email error",
  "EMAIL_DOESNOT_MATCH": "change and confirm email does not match",
  "SEND_EMAIL_ERROR": "forgot password send email error",
  "CONFIRM_EMAIL_VERIFICATION_ERROR": "verification email error",
  "VERIFY_OTP_ERROR": "verify otp error",
  "SEND_OTP_ERROR": "send otp error",
  "CREATE_COMMERCIAL_ACCOUNT_ERROR": "commercial account creation error",
  "PERSONAL_ASSISTANCE": "Need personal assistance",
  "MAKE_PAYMENT_LINK": "https://payments.mapfreinsurance.com/",
  "REPORT_CLAIM_LINK": "https://mcr.mapfreinsurance.com/claims/#/ReportClaim",
  "SEND_CLAIM_DOCUMENTS_LINK": "https://claims.mapfreinsurance.com/documents/emailClaimDocuments",
  "FIND_AGENT_LINK": "https://agents.mapfreinsurance.com/locator/agentlocator",
  "NO_PHONE_NO_EMAIL_CONTEXT": "This email will be used to login to your account. We will send you an email with a validation link to complete the set up of your account.",
  "ENTER_VALID_ADDRESS": "Please enter a valid address",
  "ACCOUNT_VERIFICATION": "Account verification",
  "USE_EMAIL": "Use email",
  "USE_DIFFERENT_EMAIL": "Use different email",
  "USE_A_DIFFERENT_EMAIL": "Use a different email",
  "NOT_A_MOBILE": "Not a mobile phone number?",
  "ZIP_CODE": "ZIP code",
  "EMAIL_IN_USE_NO_PHONE_EMAIL": "Email in use. You might already have an active account.",
  "CHECK_YOUR_EMAIL": "Check your email",
  "FORGOT_PASS_TEXT": "Forgot password?",
  "RESIDENTIAL_ADDRESS_TEXT_ID": "Address changes are limited to Idaho state.",
  "RESIDENTIAL_ADDRESS_TEXT_ID2": "If your new address is outside Idaho, please ",
  "CONTACT_US_2": "contact us",
  "RESIDENTIAL_ADDRESS_TEXT_2": "to discuss your options.",
  "GARAGED_YES": "* Please note that selecting \"Yes\" above updates where your vehicle is garaged and may change your policy ",
  "GARAGED_YES2": "premium. If any vehicle covered under this policy is garaged at a different location, ",
  "RESIDENTIAL_ADDRESS_TEXT_WA": "Address changes are limited to Washington state.",
  "RESIDENTIAL_ADDRESS_TEXT_WA2": "If your new address is outside Washington, please ",
  "RESIDENTIAL_ADDRESS_TEXT_WA_NEW": "Address changes are limited to Washington state. If your new address is outside Washington, please",
  "MA_ONLY_APP_NOTIFICATION": "This application is only available for MA policies.",
  "DONT_SHOW_AGAIN": "Don’t show again",
  "NOT_NOW": "Not now",
  "GO_MAPFRE_APP": "Go Mapfre APP",
  "MANAGE_INSURANCE": "Manage your insurance, claims, make payments and more!",
  "PAPERLESS_PROGRAM": "Paperless program",
  "HELP_US_STAY_GREEN_LOWCASE": "Help us stay green!",
  "ENROLL_IN_OUR_PAPERLESS_PROGRAM_TODAY": "Enroll in our paperless program today to receive all your documents and statements electronically.",
  "APP_UPDATE_AVAILABLE": "There is a new version of Mapfre App available",
  "REVIEW_DETAILS": "Review details",
  "CLOSE": "Close",
  "OPEN_BAY_BANNER_TITLE": "Introducing Openbay+",
  "OPEN_BAY_BANNER_DESCRIPTION_1": "Mapfre Insurance has partnered with Openbay to offer customers up to ",
  "OPEN_BAY_BANNER_DESCRIPTION_2": " in savings on auto repair and maintenance services.",
  "LEARN_MORE": "Learn more",
  "VIN": "VIN ",
  "PLATE": "Plate ",
  "PRIMARY_DRIVER": "Primary driver ",
  "OTHER_DRIVER": "Other driver(s) ",
  "CURRENT_MILEAGE": "Current mileage ",
  "LOOKING_MORE": "Looking for more?",
  "LOOKS_GOOD": "Looks good",
  "POLICY_CHANGES": "Policy changes",
  "FULL_POLICY_INFO": "Full policy information",
  "POLICY_DOCUMENTS": "Policy documents",
  "EDIT_CONTACT_DETAILS": "Edit contact details",
  "REMOVE": "Remove",
  "CONFIRM_CONTACT": "Confirm",
  "CANCEL_CONTACT": "Cancel",
  "CONFIRM_EMAIL_CONTACT": "Confirm new email",
  "MANAGE_CONTACT_DETAILS": "Manage contact details",
  "POLICY_MUST_BE_ACTIVE": "Your policy must be active and linked to your Mapfre customer account to update your contact information.",
  "EMAIL_FOR_MFA": "This email is used for logging in, updating paperless preferences, and receiving important communications from Mapfre.",
  "THIS_EMAIL_IS_USED_TO_LOG_IN_PAPERLESS": "This email is used to log in, for your paperless settings, and important communications from Mapfre.",
  "THIS_EMAIL_IS_USED_TO_LOG_IN": "This email is used to log in and for important communication from Mapfre.",
  "CONTACT_USE_DISCLOSURE_TITLE": "How we use your contact data",
  "CONTACT_USE_DISCLOSURE_TEXT": "Mapfre uses your contact data to contact you about your policy or claim and to send transactional emails about your policy. We also may send non-transactional emails providing helpful news, tips, and weather alerts. You may opt-out of non-transactional communications by clicking on the unsubscribe link at the bottom of any email. Even if you unsubscribe from these emails, you will still receive transactional emails required to manage your policy.",
  "EDIT_CONTACT": "Edit",
  "ADD_PHONE": "Add phone",
  "OTHER_PHONES": "Other phones",
  "THERE_ARE_NO_PHONE": "There are no phone numbers on your account.",
  "NO_PHONE": "There are no phone numbers associated with your account.",
  "PRIMARY_PHONE": "Primary phone",
  "THIS_IS_CONSIDERED_THE_BEST": "This is considered the best number to reach you.",
  "PLEASE_REVIEW_AND_UPDATE_YOUR": "Please review and update your contact information, so you don't miss anything important from Mapfre.",
  "UPDATE_PROFILE": "Edit my details",
  "UPDATE_ACCOUNT_EMAIL": "Update account email address",
  "CHANGE_POLICY_EMAIL": "Change policy email address",
  "ATTENTION": "Attention",
  "IMPORTANT_NOTICE": "Important notice",
  "ESTIMATED_DEDUCTION_TEXT": "Please note the estimated deduction may not include any increase or decrease in premiums due to removal of discounts or policy changes.",
  "LIKE_TO_MAKE_PAYMENT": "Would you like to make a payment now?",
  "EPAY_ENROLL_PARA_NEW_AUTOPAY": "Add your checking or savings account and choose deduction date to enroll your policy in autopay",
  "ENROLL_LOWERCASE": "Enroll",
  "EPAY_THANKYOU_TEXT_NEW": "Thanks for enrolling in autopay, we're processing your changes. Keep an eye out for an autopay statement prior to your first deduction.",
  "EPAY_PROCESS_CHANGES": "We need up to 15 days in order to process the changes requested. Keep an eye out for an autopay statement prior to your first deduction.",
  "EPAY_PROCESSING_15DAYS": "We need up to 15 days in order to process the changes requested. Check the documents tab in the billing section for the invoice.",
  "LEGACY_EFT_PROCESS_CHANGES": "We need up to 15 days in order to process the changes",
  "FAQ_NEW": "FAQ",
  "EPAY_THANK_YOU_TEXT": "Thanks for enrolling in autopay, we’re processing your changes.",
  "THANKS_SEND_MESSAGE": "Thanks for sending your message",
  "PRIOR_FIRST_DEDUCION": "Keep an eye out for an autopay statement prior to your first deduction.",
  "FIRST_DEDUCTION": "Your first autopay deduction is scheduled on",
  "ADD": "Add",
  "ZIPCODE": "ZIP code",
  "CURRENT_TERM": "Term:",
  "POLICY_CANCELLATION_TEXT": "Policy has been cancelled for",
  "POLICY_CANCELLED": "Policy has been cancelled",
  "NON_PAYMENT_TEXT": "Non-payment of insurance premium",
  "PERSONAL_INSURANCE": "Personal insurance",
  "BUSINESS_INSURANCE": "Business insurance",
  "ABOUT_POLICY": "Tell us about your policy",
  "WHAT_TYPE_OF_POLICY": "What type of policy do you have?",
  "ACCOUNT_ACTIVATION": "Account activation",
  "ACCOUNT_ACTIVATION_DESC": "This email will be used to login to your account. Check your email for the activation link to complete your account set up.",
  "CONTACT_US_TEXT": "Contact us",
  "GO_PAPERLESS": "Go paperless",
  "GO_PAPERLESS_SUBTEXT": "Get the information you need when you need it through your online account. Opt-in for paperless to reduce waste and help Mapfre Insurance stay green.",
  "NEXT_BILL": "Next bill",
  "NEXT_AMOUNT_DUE": "Next amount due**",
  "TRANSACTION_HISTORY": "Transaction history",
  "PAYMENT_PLAN": "Pay plan",
  "TOTAL_POLICY_PREMIUM": "Total policy premium",
  "VIEW_CURRENT_INVOICE": "View current invoice",
  "HAVE_A_QUESTION": "Have a question?",
  "NEED_HELP_WITH_A_BILLING_QUESTION": "Need help with a billing question, a refund, a cancellation or adding a discount? Send us a request and we'll take care of everything.",
  "SUBMIT_A_REQUEST": "Submit a request",
  "WHERE_CAN_FIND_MY_POLICY_INFO": "Where can I find my policy information?",
  "POLICY_NUMBER_MK_PAYMENT": "Policy number",
  "GO_TO_BILLING": "Go to billing",
  "CHECK_NUM": "Check number",
  "QUICK_ACCESS_SERVICES": "Quick access services",
  "SEND_CLAIM_DOCUMENTS_TEXT": "Send claim documents",
  "REPORT_A_CLAIM_TEXT": "Report a claim",
  "MAKE_A_PAYMENT_TEXT": "Make a payment",
  "LOAD_MORE_TRANSACTIONS": "Load more transactions",
  "READ_FAQ": "Read our most frequently asked questions (FAQ)",
  "CHECKOUT_MORE": "Check out your policy documents, statements, bills, and more",
  "BANK_ACCOUNT_REMOVED_TEXT": "Bank account removed",
  "CHECKING_OR_SAVINGS_ACC": "Checking/savings account",
  "GO_TO_MY_ACCOUNT": "Go to my account",
  "CHECKING_SAVINGS_ACCOUNT": "Checking / savings account",
  "CREDIT_DEBIT_CARD": "Credit / debit card",
  "TO_TEXT": "to",
  "CHOOSE_POLICY": "Choose policy *",
  "CHOOSE_TOPIC": "Topic *",
  "MAKE_ANOTHER_PAYMENT": "Make another payment",
  "MANAGE_AUTOPAY": "Manage autopay",
  "SUCCESSFUL_PAYMENT": "Successful payment",
  "MISC_QUESTIONS": "Other questions",
  "CHECKING_SAVINGS_ACCOUNT_UNAVAILABLE_AS400": "These features are only available for personal policies and are not currently available for commercial policies:",
  "ENABLE_AUTO_PAY": "Enable autopay now",
  "LET_US_DO_THE_WORK_FOR_YOU": "Let us do the work for you with automatic payments",
  "ENROLL_IN_AUTOPAY": "Enroll in autopay",
  "HAVE_QUESTIONS": "Have questions?",
  "PLEASE_NOTE": "Please note",
  "RESPONSE_WITHIN_TWO_FOUR": "You will receive a response within 2 business days.",
  "SAVING_CHECKING_ACC_INFO": "Saving checking and/or savings account information",
  "SELECT_POLICY": "Select your policy*",
  "DIGITAL_WALLET_FUNCTIONALITY": "Digital wallet functionality",
  "WHAT_CAN_WE_HELP": "What can we help you with?",
  "REPLY_TWO_FOUR_DAYS": "We will reply within 2 to 4 business days and reach out if we have any questions.",
  "TELL_ABOUT_REQUEST": "Tell us more about your request:",
  "SELECT_TOPIC": "Select topic*",
  "SELECT_REASON_STAR": "Select a reason*",
  "SEND_MESSAGE": "Send message",
  "ADD_ADDITIONAL_INFO_REQUIRED": "Add additional information*",
  "ADD_ADDITIONAL_INFO": "Add additional information",
  "ADD_INFO_CANCEL_POLICY": "Additional information will be needed to cancel your policy. Please let us know if the plates are being returned or you have obtained new insurance with another carrier.",
  "SELECT_CANCEL_REASON": "Select cancellation reason*",
  "SELECT_REASON": "Select a reason",
  "CANCELLATION": "Cancellation",
  "NEXT_STEP": "Next step: ",
  "MA_AUTO_TRANSFER_INSURANCE": "Massachusetts Auto Transfer of Insurance 2A Form",
  "UPLOAD_MA_AUTO_TRANSFER_INSURANCE": "Upload a copy of your Massachusetts Auto Transfer of Insurance 2A Form or a copy of your new policy declaration page provided to you by your insurance agent. This documentation is required by Massachusetts law and your policy cannot be canceled until we receive the Transfer of Insurance 2A Form.",
  "UPLOAD_DOCS": "Upload documents",
  "UPLOAD_COPY_LICENSE_PLATE": "It is required by Massachusetts law to return your license plates to the Registry of Motor Vehicles. Upload a copy of the plate return receipt with this request. If you have not yet canceled your plates, you can start the process on the ",
  "POLICY_NOY_CANCEL_UNTIL_PLATE": "Your policy cannot be canceled until we receive the plate return receipt document.",
  "2A_FORM_INFO": "A 2A form is used to remove a car from your auto insurance policy. To cancel your policy, you must either cancel the plates or send us a 2A form showing the vehicle is now insured with a different insurance company. The form is always labeled as \"Notice of Transfer of Insured\" and will have a new carrier stamp on it.",
  "2A_FORM_TITLE": "What is a Massachusetts Auto Transfer of Insurance 2A Form?",
  "THANK_SUBMITTING": "Thanks for submitting your ",
  "CANCEL_REQUEST": "cancellation request",
  "NOT_RECEIVE_CONFIRM_CALL_US": "If you have not received your confirmation of cancellation within 10 days, please call us ",
  "REPLY_WITHIN_TWO_FOUR_CANCEL_REQUEST": "As a reminder, your policy will remain active while we review your cancellation request, we will reply within 2 business days and reach out if we have any questions.",
  "CANCEL_REQUEST_PROPERTY": "For cancellation requests of your property policy you must ",
  "CANCEL_REQUEST_UMBRELLA": "For cancellation requests of your umbrella policy you must ",
  "FILE_TOO_LARGE": "The file is too large to upload",
  "FILES_LARGER_THAN_20MB": "Files larger than 20 MB are not supported, reduce the size of the file and try again.",
  "REMOVE_FILE": "Remove file",
  "YOU_SURE_REMOVE": "Are you sure you want to remove",
  "YOU_EXIT_FILES_LOST": "If you exit any uploaded files will be lost",
  "TRY_AGAIN_LATER": "Try again later",
  "PROBLEM_WITH_SUBMISSION": "There was a problem with the submission",
  "IF_NEED_IMMEDIATE_ASSISTANCE": "If you need immediate assistance, please ",
  "SATURDAY_EST": "Saturday 8 am - 5 pm EST",
  "MONDAY_FRIDAY_EST": "Monday to Friday 7 am - 9 pm EST",
  "REFUND_APPROVED": "All refund requests are subject to review. If approved, a refund will be issued in an additional 5 business days.",
  "UNCASHED_REFUND_LETTER_APPROVED": "All refund requests are subject to review. You will be notified of our decision. Approved refunds are issued within 5 business days. If you elect your refund to be issued by check through US Mail, allow an additional 14 days for receipt.",
  "DIGITAL_REFUND": "To get your refund faster, are you interested in a digital refund?",
  "CONFIRM_INFO_TO_REFUND": "For you to receive a refund, confirm your information:",
  "UPDATE_CORRECT_INFO_TO_POLICY": "Corrected information will be updated on your policy.",
  "IF_PAYEE_INCORRECT": "If the payee is incorrect, please ",
  "HAVE_POLICY_CORRECTED": "to have the policy corrected.",
  "AAA_MEMBERSHIP_VALIDATION": "AAA membership validation",
  "AAA_MEMBERSHIP_VALIDATION_APPLIED": "AAA membership validation must be applied within the first 60 days of your Mapfre auto policy effective date.",
  "THANKS_SUBMITTING_AAA_MEMBERSHIP": "Thanks for submitting your AAA membership validation request",
  "RATE_APPLY_DAYS": "The AAA rate can only be applied within the first 60 days of your policy term.",
  "AAA_MEMBERSHIp_PREMIUM_CHANGE": "If your AAA membership results in a premium change, credits will be applied to any outstanding balance or refunded to the mailing address on file if your account is paid in full",
  "REPLY_WITHIN_BUSINESS_DAYS": "We will reply within 2 to 4 business days and reach out if we have any questions.",
  "IF_THE_PAYEE_IS": "If the Payee is",
  "INCORRECT_NO_LOGINER": "incorrect, no longer listed on the policy or should not have been listed on the policy,",
  "PLEASE": "please",
  "CONTACT_YOUR_AGENT_LOWERCASE": "contact your agent",
  "TO_HAVE_THE_POLICY_CORRECTED": "to have the policy corrected.",
  "PAYEE": "Payee",
  "REFUNDS": "Refunds",
  "REFUND_AMOUNTS_ARE_THE_DIFFERENCE": "Refund amounts are the difference calculated between what is owed on the policy less any overpayments or credits.",
  "SELECTION_IS_REQUIRED": "Selection is required",
  "SELECT_DISCOUNT": "Select discount*",
  "THE_GOOD_STUDENT_DISCOUNT": "The Good Student discount is applicable for drivers under the age of 21 who maintain at least a 'B' average GPA or are included on the \"Dean's list\" or \"Honor roll”.",
  "THE_MOST_CURRENT_STUDENT": "The most current student transcript is required. Upload documentation below.",
  "THE_PANMASS_CHALLENGE_DISCOUNT": "The Marketing Partner Discount is valid for one term and the donation date to the Pan-Mass Challenge must be 60 days or more prior to the policy effective date.",
  "A_DONATION_RECEIPT": "A donation receipt as proof of your donation of $50 or more is required. Upload documentation below.",
  "FOR_THIS_DISCOUNT_TO_APPLY": "For this discount to apply, the applicable driver must be attending college over 100 miles from the residential address.",
  "A_COPY_OF_THE_DRIVERS": "A copy of the driver’s college transcript or acceptance paperwork is required. Upload documentation below.",
  "DOCUMENT_NAME": "Document name",
  "SUBMIT_EXPIRED_CHECK": "expired check request",
  "SUBMIT_UNCACHED_CHECK": "uncashed refund letter request",
  "SUBMIT_LOST_CHECK": "lost check request",
  "QUESTION_ABOUT_MY_REFUND_STATUS_PART_ONE": "All refund requests are subject to review, you will be notified of our decision.",
  "QUESTION_ABOUT_MY_REFUND_STATUS_PART_TWO": "If it has been over 30 days since your refund was requested, tell us below and we will get back to you.",
  "SUBMIT_A_QUESTION": "Submit a Question",
  "UPLOAD_SUCCESS_SUB_TEXT": "We will reply within 2 business days if needed, and reach out if we have any questions.",
  "MORTGAGEE_TEXT": "Mortgagee billed",
  "MORTGAGEE_DETAILS": "Mortgagee details",
  "PROCEED_PAYMENT": "Proceed with payment",
  "MORTGAGEE_MODAL_MESSAGE_ONE": "This policy is paid by your mortgage company.",
  "MORTGAGEE_MODAL_MESSAGE_TWO": "Would you still like to proceed?",
  "WELCOME_TO_HOMEPAGE": "Welcome to your Mapfre Insurance homepage!",
  "REQUIRED": "Required",
  "PAY_BY_TEXT_PAYMENT": "your saved payment methods will need to be re-entered.",
  "PAYMENT_UPDATE_EMAIL_TEXT": "An email reminder with a payment link will be sent seven days before your due date.",
  "PAYMENT_UPDATE_INFO_TEXT": "Starting now, all payment reminders will be sent by email, with a link to pay seven days before your due date.",
  "PAYMENT_UPDATE": "Action required: Update your payment method",
  "PAYMENT_BEGIN_TXT": "Due to a system update on",
  "THANKS_SEND_MSG":"Thanks for submitting your question!",
  "REPLY_TWO_DAYS":"We will respond within 2 business days.",
  "REPLY_WITHIN_TWO_DAYS": "We will reply within 2 business days and reach out if we have any questions.",
  "AUTOPAY_MA": "autopay",
  "MANAGE_EMAIL_TEXT": "Manage your email in ",
  "CONTACT_DETAILS": "Contact details",
  "MANAGE_PAPERLESS": "Manage paperless",
  "CONFIRM_ENROLL_PAPERLESS": "Confirm you want to enroll your",
  "POLICY_PAPERLESS": "policy",
  "IN_PAPERLESS_ENROLL": "in paperless",
  "UNENROLL_CONFIRM_TEXT": "Looking to unenroll your",
  "KEEP_ME_ENROLLED": "Keep me enrolled",
  "NON_RENEWAL_NOTICE": "Notice of Nonrenewal",
  "YOUR_POLICY": "Your policy,",
  "WILL_EXPIRE": "will expire on",
  "NOTICE_TEXT": "and will not be renewed for the reasons stated in the nonrenewal notice mailed to you.",
  "MULTIPLE_POLICIES_NOTICE_TEXT": "The following policies will not be renewed for the reasons stated in the nonrenewal notice mailed to you.",
  "EXPIRES_ON": "expires on"
}
